/**
 * Copyright IBM Corp. 2016, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { i as iconPropTypes, _ as _objectWithoutProperties, I as Icon, a as _objectSpread2 } from '../iconPropTypes-44033017.js';
import React from 'react';
import '@carbon/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _switch, _circle, _circle2, _circle3, _circle4, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _circle5, _circle6, _circle7, _path43, _path44, _circle8, _circle9, _path45, _circle10, _path46, _path47, _path48, _path49, _circle11, _path50, _circle12, _path51, _circle13, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _circle14, _circle15, _path70, _circle16, _circle17, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _circle18, _path106, _path107, _path108, _circle19, _path109, _path110, _path111, _circle20, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _circle21, _path147, _path148, _circle22, _path149, _circle23, _path150, _path151, _circle24, _path152, _circle25, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _circle26, _circle27, _circle28, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _circle29, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _circle30, _path227, _path228, _circle31, _path229, _path230, _circle32, _path231, _path232, _path233, _path234, _path235, _rect, _path236, _path237;

var _excluded = ["children", "size"],
    _excluded2 = ["children", "size"],
    _excluded3 = ["children", "size"],
    _excluded4 = ["children", "size"],
    _excluded5 = ["children", "size"],
    _excluded6 = ["children", "size"],
    _excluded7 = ["children", "size"],
    _excluded8 = ["children", "size"],
    _excluded9 = ["children", "size"],
    _excluded10 = ["children", "size"],
    _excluded11 = ["children", "size"],
    _excluded12 = ["children", "size"],
    _excluded13 = ["children", "size"],
    _excluded14 = ["children", "size"],
    _excluded15 = ["children", "size"],
    _excluded16 = ["children", "size"],
    _excluded17 = ["children", "size"],
    _excluded18 = ["children", "size"],
    _excluded19 = ["children", "size"],
    _excluded20 = ["children", "size"],
    _excluded21 = ["children", "size"],
    _excluded22 = ["children", "size"],
    _excluded23 = ["children", "size"],
    _excluded24 = ["children", "size"],
    _excluded25 = ["children", "size"],
    _excluded26 = ["children", "size"],
    _excluded27 = ["children", "size"],
    _excluded28 = ["children", "size"],
    _excluded29 = ["children", "size"],
    _excluded30 = ["children", "size"],
    _excluded31 = ["children", "size"],
    _excluded32 = ["children", "size"],
    _excluded33 = ["children", "size"],
    _excluded34 = ["children", "size"],
    _excluded35 = ["children", "size"],
    _excluded36 = ["children", "size"],
    _excluded37 = ["children", "size"],
    _excluded38 = ["children", "size"],
    _excluded39 = ["children", "size"],
    _excluded40 = ["children", "size"],
    _excluded41 = ["children", "size"],
    _excluded42 = ["children", "size"],
    _excluded43 = ["children", "size"],
    _excluded44 = ["children", "size"],
    _excluded45 = ["children", "size"],
    _excluded46 = ["children", "size"],
    _excluded47 = ["children", "size"],
    _excluded48 = ["children", "size"],
    _excluded49 = ["children", "size"],
    _excluded50 = ["children", "size"],
    _excluded51 = ["children", "size"],
    _excluded52 = ["children", "size"],
    _excluded53 = ["children", "size"],
    _excluded54 = ["children", "size"],
    _excluded55 = ["children", "size"],
    _excluded56 = ["children", "size"],
    _excluded57 = ["children", "size"],
    _excluded58 = ["children", "size"],
    _excluded59 = ["children", "size"],
    _excluded60 = ["children", "size"],
    _excluded61 = ["children", "size"],
    _excluded62 = ["children", "size"],
    _excluded63 = ["children", "size"],
    _excluded64 = ["children", "size"],
    _excluded65 = ["children", "size"],
    _excluded66 = ["children", "size"],
    _excluded67 = ["children", "size"],
    _excluded68 = ["children", "size"],
    _excluded69 = ["children", "size"],
    _excluded70 = ["children", "size"],
    _excluded71 = ["children", "size"],
    _excluded72 = ["children", "size"],
    _excluded73 = ["children", "size"],
    _excluded74 = ["children", "size"],
    _excluded75 = ["children", "size"],
    _excluded76 = ["children", "size"],
    _excluded77 = ["children", "size"],
    _excluded78 = ["children", "size"],
    _excluded79 = ["children", "size"],
    _excluded80 = ["children", "size"],
    _excluded81 = ["children", "size"],
    _excluded82 = ["children", "size"],
    _excluded83 = ["children", "size"],
    _excluded84 = ["children", "size"],
    _excluded85 = ["children", "size"],
    _excluded86 = ["children", "size"],
    _excluded87 = ["children", "size"],
    _excluded88 = ["children", "size"],
    _excluded89 = ["children", "size"],
    _excluded90 = ["children", "size"],
    _excluded91 = ["children", "size"],
    _excluded92 = ["children", "size"],
    _excluded93 = ["children", "size"],
    _excluded94 = ["children", "size"],
    _excluded95 = ["children", "size"],
    _excluded96 = ["children", "size"],
    _excluded97 = ["children", "size"],
    _excluded98 = ["children", "size"],
    _excluded99 = ["children", "size"],
    _excluded100 = ["children", "size"],
    _excluded101 = ["children", "size"],
    _excluded102 = ["children", "size"],
    _excluded103 = ["children", "size"],
    _excluded104 = ["children", "size"],
    _excluded105 = ["children", "size"],
    _excluded106 = ["children", "size"],
    _excluded107 = ["children", "size"],
    _excluded108 = ["children", "size"],
    _excluded109 = ["children", "size"],
    _excluded110 = ["children", "size"],
    _excluded111 = ["children", "size"],
    _excluded112 = ["children", "size"],
    _excluded113 = ["children", "size"],
    _excluded114 = ["children", "size"],
    _excluded115 = ["children", "size"],
    _excluded116 = ["children", "size"],
    _excluded117 = ["children", "size"],
    _excluded118 = ["children", "size"],
    _excluded119 = ["children", "size"],
    _excluded120 = ["children", "size"],
    _excluded121 = ["children", "size"],
    _excluded122 = ["children", "size"],
    _excluded123 = ["children", "size"],
    _excluded124 = ["children", "size"],
    _excluded125 = ["children", "size"];
var didWarnAboutDeprecation = {};
var IbmCloudPal = /*#__PURE__*/React.forwardRef(function IbmCloudPal(_ref, ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 16 : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5,17.7l-6-3.5C24.4,14,24.2,14,24,14s-0.4,0-0.5,0.1l-6,3.5c-0.3,0.2-0.5,0.5-0.5,0.9v6.9c0,0.4,0.2,0.7,0.5,0.9l6,3.5 C23.6,30,23.8,30,24,30s0.4,0,0.5-0.1l6-3.5c0.3-0.2,0.5-0.5,0.5-0.9v-6.9C31,18.2,30.8,17.9,30.5,17.7z M29,24.9l-5,3l-5-3v-5.8 l5-3l5,3V24.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14,26H9c-4.4,0-8-3.6-8-8c0-3.7,2.6-6.9,6.2-7.8C8,5.5,12.1,2,17,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8 c-4.1,0-7.5,3.1-8,7.2L9,12l-0.8,0.1C5.2,12.5,3,15,3,18c0,3.3,2.7,6,6,6h5V26z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmCloudPal.propTypes = iconPropTypes;
}
var IbmCloudSecretsManager = /*#__PURE__*/React.forwardRef(function IbmCloudSecretsManager(_ref2, ref) {
  var children = _ref2.children,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 16 : _ref2$size,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20,16c0-0.7-0.2-1.4-0.6-2l3.3-3.3l-1.4-1.4L18,12.6c-0.6-0.4-1.3-0.6-2-0.6c-0.7,0-1.4,0.2-2,0.6l-3.3-3.3l-1.4,1.4 l3.3,3.3c-0.4,0.6-0.6,1.3-0.6,2c0,0.7,0.2,1.4,0.6,2l-3.3,3.3l1.4,1.4l3.3-3.3c0.6,0.4,1.3,0.6,2,0.6c0.7,0,1.4-0.2,2-0.6l3.3,3.3 l1.4-1.4L19.4,18C19.8,17.4,20,16.7,20,16z M16,18c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2C18,17.1,17.1,18,16,18z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26,17h6v-2h-2.1C29.4,7.7,23.4,2,16,2C8.3,2,2,8.3,2,16s6.3,14,14,14c5.2,0,9.7-2.8,12.1-7l-1.7-1c-2.1,3.6-5.9,6-10.4,6 C9.4,28,4,22.6,4,16C4,9.4,9.4,4,16,4c6.3,0,11.4,4.9,11.9,11H26V17z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmCloudSecretsManager.propTypes = iconPropTypes;
}
var IbmCloudSecurityComplianceCenter = /*#__PURE__*/React.forwardRef(function IbmCloudSecurityComplianceCenter(_ref3, ref) {
  var children = _ref3.children,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 16 : _ref3$size,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30,18v5.5c0,1.5-0.9,2.8-2.3,3.5L26,27.8 L24.3,27c-1.4-0.6-2.3-2-2.3-3.5V18H30 M32,16H20v7.5c0,2.2,1.3,4.3,3.4,5.3L26,30l2.6-1.2c2.1-1,3.4-3,3.4-5.3V16L32,16z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25H7.5C3.4,25,0,21.6,0,17.5c0-3.7,2.7-6.7,6.2-7.4C7.1,5.4,11.2,2,16,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8 c-4.1,0-7.5,3.1-8,7.1L8,12L7.1,12C4.2,12.2,2,14.6,2,17.5c0,3,2.5,5.5,5.5,5.5H16V25z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmCloudSecurityComplianceCenter.propTypes = iconPropTypes;
}
var IbmCloudSubnets = /*#__PURE__*/React.forwardRef(function IbmCloudSubnets(_ref4, ref) {
  var children = _ref4.children,
      _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 16 : _ref4$size,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a3.6069,3.6069,0,0,0-2,.6L19.4143,18,18,19.4141,22.6,24a4.1755,4.1755,0,0,0-.4,1H9.8583A3.5525,3.5525,0,0,0,9.4,24L24,9.4a3.6069,3.6069,0,0,0,2,.6,4,4,0,1,0-3.8569-5H9.9A4.0785,4.0785,0,0,0,6,2a4,4,0,0,0,0,8,3.6066,3.6066,0,0,0,2-.6L12.5858,14,14,12.5859,9.4,8a4.175,4.175,0,0,0,.4-1H22.1418A3.5553,3.5553,0,0,0,22.6,8L8,22.6A3.6066,3.6066,0,0,0,6,22a4,4,0,1,0,3.8569,5H22.1A4.0118,4.0118,0,1,0,26,22ZM26,4a2,2,0,1,1-2,2A2.0058,2.0058,0,0,1,26,4ZM6,8A2,2,0,1,1,8,6,2.0058,2.0058,0,0,1,6,8ZM6,28a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmCloudSubnets.propTypes = iconPropTypes;
}
var IbmCloudSysdigSecure = /*#__PURE__*/React.forwardRef(function IbmCloudSysdigSecure(_ref5, ref) {
  var children = _ref5.children,
      _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? 16 : _ref5$size,
      rest = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25,14l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V2h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,14z M22,4v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6 l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4H22z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6h12V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmCloudSysdigSecure.propTypes = iconPropTypes;
}
var IbmCloudTransitGateway = /*#__PURE__*/React.forwardRef(function IbmCloudTransitGateway(_ref6, ref) {
  var children = _ref6.children,
      _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? 16 : _ref6$size,
      rest = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9,20.9l3.5-3.5a1.9333,1.9333,0,0,0,0-2.8L24.1,9.3l1.4-1.4A.9015.9015,0,0,0,26,8a2,2,0,1,0-2-2,.9015.9015,0,0,0,.1.5L18,12.6a3.6333,3.6333,0,0,0-4,0L10.7,9.3,16,4l3.5,3.5,1.4-1.4L17.4,2.6a1.9333,1.9333,0,0,0-2.8,0L9.3,7.9,7.9,6.5A.9015.9015,0,0,0,8,6,2,2,0,1,0,6,8a.9015.9015,0,0,0,.5-.1L12.6,14a3.6333,3.6333,0,0,0,0,4L9.3,21.3,4,16l3.5-3.5L6.1,11.1,2.6,14.6a1.9333,1.9333,0,0,0,0,2.8l5.3,5.3L6.5,24.1A.9015.9015,0,0,0,6,24a2,2,0,1,0,2,2,.9015.9015,0,0,0-.1-.5L14,19.4a3.6333,3.6333,0,0,0,4,0l3.3,3.3L16,28l-3.5-3.5-1.4,1.4,3.5,3.5a1.9333,1.9333,0,0,0,2.8,0l5.3-5.3,1.4,1.4c0,.2-.1.3-.1.5a2,2,0,1,0,2-2,.9015.9015,0,0,0-.5.1L19.4,18a3.6333,3.6333,0,0,0,0-4l3.3-3.3L28,16l-3.5,3.5ZM16,18a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmCloudTransitGateway.propTypes = iconPropTypes;
}
var IbmCloudVpcEndpoints = /*#__PURE__*/React.forwardRef(function IbmCloudVpcEndpoints(_ref7, ref) {
  var children = _ref7.children,
      _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? 16 : _ref7$size,
      rest = _objectWithoutProperties(_ref7, _excluded7);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20,27H7a2.0059,2.0059,0,0,1-2-2V12H7V25H20Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4,22l-4-4a3.6057,3.6057,0,0,0,.6-2,4.0118,4.0118,0,0,0-4-4,3.6057,3.6057,0,0,0-2,.6l-4-4V2H2v8H8.6l4,4a3.6057,3.6057,0,0,0-.6,2,4.0118,4.0118,0,0,0,4,4,3.6057,3.6057,0,0,0,2-.6l4,4V30h8V22ZM8,8H4V4H8Zm8,10a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18ZM28,28H24V24h4Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25,20h2V7a2.0059,2.0059,0,0,0-2-2H12V7H25Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmCloudVpcEndpoints.propTypes = iconPropTypes;
}
var IbmCloudPakApplications = /*#__PURE__*/React.forwardRef(function IbmCloudPakApplications(_ref8, ref) {
  var children = _ref8.children,
      _ref8$size = _ref8.size,
      size = _ref8$size === void 0 ? 16 : _ref8$size,
      rest = _objectWithoutProperties(_ref8, _excluded8);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21,22H15a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,21,22Zm-6-6v4h6V16Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11,17H9V12a2.0023,2.0023,0,0,1,2-2h6v2H11Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmCloudPakApplications.propTypes = iconPropTypes;
}
var IbmCloudPakBusinessAutomation = /*#__PURE__*/React.forwardRef(function IbmCloudPakBusinessAutomation(_ref9, ref) {
  var children = _ref9.children,
      _ref9$size = _ref9.size,
      size = _ref9$size === void 0 ? 16 : _ref9$size,
      rest = _objectWithoutProperties(_ref9, _excluded9);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25,16c0-1.5-1.2-2.8-2.7-3c-1.1-2.4-3.5-4-6.3-4c-0.2,0-0.5,0-0.7,0.1C14.7,8.4,13.9,8,13,8c-1.7,0-3,1.3-3,3 c0,0.4,0.1,0.7,0.2,1.1C9.4,13.2,9,14.5,9,16s0.4,2.8,1.2,3.9C10.1,20.3,10,20.6,10,21c0,1.7,1.3,3,3,3c0.9,0,1.7-0.4,2.3-1.1 c0.2,0,0.5,0.1,0.7,0.1c2.8,0,5.2-1.7,6.3-4C23.8,18.8,25,17.5,25,16z M13,10c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1 S12.4,10,13,10z M13,22c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S13.6,22,13,22z M16,21c0-1.7-1.3-3-3-3c-0.5,0-1,0.1-1.4,0.4 C11.2,17.7,11,16.9,11,16s0.2-1.7,0.6-2.4C12,13.9,12.5,14,13,14c1.7,0,3-1.3,3-3c1.9,0,3.4,1,4.3,2.5C19.5,14.1,19,15,19,16 s0.5,1.9,1.3,2.5C19.4,20,17.9,21,16,21z M22,17c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,17,22,17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,31c-0.2,0-0.3,0-0.5-0.1l-12-7C3.2,23.7,3,23.4,3,23V9c0-0.4,0.2-0.7,0.5-0.9l12-7c0.3-0.2,0.7-0.2,1,0l12,7l-1,1.7 L16,3.2L5,9.6v12.9l11,6.4l11-6.4V15h2v8c0,0.4-0.2,0.7-0.5,0.9l-12,7C16.3,31,16.2,31,16,31z"
  })))), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmCloudPakBusinessAutomation.propTypes = iconPropTypes;
}
var IbmCloudPakData = /*#__PURE__*/React.forwardRef(function IbmCloudPakData(_ref10, ref) {
  var children = _ref10.children,
      _ref10$size = _ref10.size,
      size = _ref10$size === void 0 ? 16 : _ref10$size,
      rest = _objectWithoutProperties(_ref10, _excluded10);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "15",
    r: "1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "15",
    r: "1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "10",
    r: "1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "23",
    r: "1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257A2.9642,2.9642,0,0,0,19,16a3.0033,3.0033,0,0,0-3-3,2.9642,2.9642,0,0,0-1.3187.3187l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258A2.9634,2.9634,0,0,0,13,16a3.0033,3.0033,0,0,0,3,3,2.9634,2.9634,0,0,0,1.3188-.3188l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,17Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmCloudPakData.propTypes = iconPropTypes;
}
var IbmCloudPakIntegration = /*#__PURE__*/React.forwardRef(function IbmCloudPakIntegration(_ref11, ref) {
  var children = _ref11.children,
      _ref11$size = _ref11.size,
      size = _ref11$size === void 0 ? 16 : _ref11$size,
      rest = _objectWithoutProperties(_ref11, _excluded11);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1213 9.8787a3 3 0 00-4.2426 0l-.4645.4644 1.4142 1.4142.4645-.4645a1 1 0 011.4142 1.4144L17.4142 16l1.4143 1.4142 3.2928-3.2929A3 3 0 0022.1213 9.8787zM12.7071 20.7072a1 1 0 01-1.4142-1.4144L14.5858 16l-1.4142-1.4142L9.8787 17.8787a3 3 0 104.2426 4.2426l.4645-.4644-1.4142-1.4143zM14.1213 9.8787a3 3 0 00-4.2426 4.2426l.4645.4645 1.4142-1.4142-.4645-.4645a1 1 0 011.4142-1.4143L16 14.5858l1.4142-1.4143z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1213,17.8787l-.4645-.4645-1.4141,1.4142.4644.4645a1,1,0,0,1-1.4142,1.4143L16,17.4142l-1.4142,1.4142,3.2929,3.2929a3,3,0,0,0,4.2426-4.2426Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmCloudPakIntegration.propTypes = iconPropTypes;
}
var IbmCloudPakMantaAutomatedDataLineage = /*#__PURE__*/React.forwardRef(function IbmCloudPakMantaAutomatedDataLineage(_ref12, ref) {
  var children = _ref12.children,
      _ref12$size = _ref12.size,
      size = _ref12$size === void 0 ? 16 : _ref12$size,
      rest = _objectWithoutProperties(_ref12, _excluded12);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30,11V5H24V7H14V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4v8a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V9a3.0033,3.0033,0,0,1,3,3v9H11V19H5v6h6V23h6v2a2.0025,2.0025,0,0,0,2,2h5v2h6V23H24v2H19V18h5v2h6V14H24v2H19V12a4.9521,4.9521,0,0,0-1.0254-3H24v2ZM4,12V4h8v8ZM9,23H7V21H9Zm17,2h2v2H26Zm0-9h2v2H26Zm0-9h2V9H26Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmCloudPakMantaAutomatedDataLineage.propTypes = iconPropTypes;
}
var IbmCloudPakMulticloudMgmt = /*#__PURE__*/React.forwardRef(function IbmCloudPakMulticloudMgmt(_ref13, ref) {
  var children = _ref13.children,
      _ref13$size = _ref13.size,
      size = _ref13$size === void 0 ? 16 : _ref13$size,
      rest = _objectWithoutProperties(_ref13, _excluded13);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257a2.8876,2.8876,0,0,0,0-2.6374l.0257.0257,1.7814-1.7813a2.0345,2.0345,0,1,0-1.4141-1.4141L17.293,13.293l.0257.0257a2.8876,2.8876,0,0,0-2.6374,0l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258a2.8872,2.8872,0,0,0,0,2.6376l-.0258-.0258-1.7814,1.7813a2.0345,2.0345,0,1,0,1.4141,1.4141L14.707,18.707l-.0258-.0258a2.8872,2.8872,0,0,0,2.6376,0l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,17Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmCloudPakMulticloudMgmt.propTypes = iconPropTypes;
}
var IbmCloudPakNetezza = /*#__PURE__*/React.forwardRef(function IbmCloudPakNetezza(_ref14, ref) {
  var children = _ref14.children,
      _ref14$size = _ref14.size,
      size = _ref14$size === void 0 ? 16 : _ref14$size,
      rest = _objectWithoutProperties(_ref14, _excluded14);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10L19 19.2 13.5 10 11 10 11 22 13 22 13 12.8 18.5 22 21 22 21 10z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2s14,6.3,14,14S23.7,30,16,30z M16,4C9.4,4,4,9.4,4,16s5.4,12,12,12s12-5.4,12-12 S22.6,4,16,4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmCloudPakNetezza.propTypes = iconPropTypes;
}
var IbmCloudPakNetworkAutomation = /*#__PURE__*/React.forwardRef(function IbmCloudPakNetworkAutomation(_ref15, ref) {
  var children = _ref15.children,
      _ref15$size = _ref15.size,
      size = _ref15$size === void 0 ? 16 : _ref15$size,
      rest = _objectWithoutProperties(_ref15, _excluded15);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3638,21.364,20.95,19.95a6.9993,6.9993,0,0,0,0-9.899L22.3638,8.636a9,9,0,0,1,0,12.728Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5356 18.5354l-1.414-1.4141a3.0039 3.0039 0 000-4.2426l1.414-1.4141A5.0048 5.0048 0 0119.5356 18.5354zM17 26H15V15a1 1 0 011-1h0a1 1 0 011 1zM12.4644 18.5354a5.0048 5.0048 0 010-7.0708l1.414 1.4141a3.0039 3.0039 0 000 4.2426z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6362,21.364a9,9,0,0,1,0-12.728L11.05,10.0505a6.9993,6.9993,0,0,0,0,9.899Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmCloudPakNetworkAutomation.propTypes = iconPropTypes;
}
var IbmCloudPakSecurity = /*#__PURE__*/React.forwardRef(function IbmCloudPakSecurity(_ref16, ref) {
  var children = _ref16.children,
      _ref16$size = _ref16.size,
      size = _ref16$size === void 0 ? 16 : _ref16$size,
      rest = _objectWithoutProperties(_ref16, _excluded16);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23.7285a6.0069,6.0069,0,0,1-6-6v-6.457l6-3,6,3v6.457A6.0069,6.0069,0,0,1,16,23.7285ZM12,12.5073v5.2212a4,4,0,0,0,8,0V12.5073l-4-2Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmCloudPakSecurity.propTypes = iconPropTypes;
}
var IbmCloudPakSystem = /*#__PURE__*/React.forwardRef(function IbmCloudPakSystem(_ref17, ref) {
  var children = _ref17.children,
      _ref17$size = _ref17.size,
      size = _ref17$size === void 0 ? 16 : _ref17$size,
      rest = _objectWithoutProperties(_ref17, _excluded17);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.671H17V15.328H15z",
    transform: "rotate(-45 16 13.5)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.672H17V20.329H15z",
    transform: "rotate(-45 16 18.5)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M19,24H13a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2V22A2.0023,2.0023,0,0,1,19,24ZM13,10V22h6.0012L19,10Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmCloudPakSystem.propTypes = iconPropTypes;
}
var IbmCloudPakWatsonAiops = /*#__PURE__*/React.forwardRef(function IbmCloudPakWatsonAiops(_ref18, ref) {
  var children = _ref18.children,
      _ref18$size = _ref18.size,
      size = _ref18$size === void 0 ? 16 : _ref18$size,
      rest = _objectWithoutProperties(_ref18, _excluded18);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M14,24a1,1,0,0,1-.9614-.7253L11.2456,17H8V15h4a1,1,0,0,1,.9614.7253L14,19.36,17.0386,8.7253a1,1,0,0,1,1.9228,0L20.7544,15H24v2H20a1,1,0,0,1-.9614-.7253L18,12.64,14.9614,23.2747A1,1,0,0,1,14,24Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmCloudPakWatsonAiops.propTypes = iconPropTypes;
}
var IbmSecurity = /*#__PURE__*/React.forwardRef(function IbmSecurity(_ref19, ref) {
  var children = _ref19.children,
      _ref19$size = _ref19.size,
      size = _ref19$size === void 0 ? 16 : _ref19$size,
      rest = _objectWithoutProperties(_ref19, _excluded19);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16,.0005,4,5.9784V20.0443a12,12,0,0,0,24,0V5.9784Zm6.83,27.3138L16,23.9119V26.14l5.0361,2.5088A10.0025,10.0025,0,0,1,6,20.0443V7.21L16,2.2284,26,7.21v3.75L16,5.9783V8.2062l10,4.9816v3.75L16,11.9562v2.2279l10,4.9815v.8787a9.9045,9.9045,0,0,1-.37,2.6871L16,17.934v2.2279l8.8952,4.4313A10.0252,10.0252,0,0,1,22.83,27.3143Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmSecurity.propTypes = iconPropTypes;
}
var IbmSecurityServices = /*#__PURE__*/React.forwardRef(function IbmSecurityServices(_ref20, ref) {
  var children = _ref20.children,
      _ref20$size = _ref20.size,
      size = _ref20$size === void 0 ? 16 : _ref20$size,
      rest = _objectWithoutProperties(_ref20, _excluded20);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20a2.97,2.97,0,0,0-1.8551.6607L22,19.4224V17.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,16,20a3.02,3.02,0,1,0,2.9254,2.3525L21,21.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,26,20ZM16,24a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,24Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,14Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,26,24Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31A11.0125,11.0125,0,0,1,5,20V6.3823L15.9873.8816,26.4478,6.1187l-.8956,1.7885L15.9873,3.1184,7,7.6177V20a9.0008,9.0008,0,0,0,14.3994,7.2012L22.6006,28.8A10.9077,10.9077,0,0,1,16,31Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmSecurityServices.propTypes = iconPropTypes;
}
var IbmWatsonAssistant = /*#__PURE__*/React.forwardRef(function IbmWatsonAssistant(_ref21, ref) {
  var children = _ref21.children,
      _ref21$size = _ref21.size,
      size = _ref21$size === void 0 ? 16 : _ref21$size,
      rest = _objectWithoutProperties(_ref21, _excluded21);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H18c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H18V4h10v6h-3v2h3c1.1 0 2-.9 2-2V4C30 2.9 29.1 2 28 2zM14.7 31L13 30l3.5-6H22c1.1 0 2-.9 2-2v-5h2v5c0 2.2-1.8 4-4 4h-4.4L14.7 31z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "17",
    r: "1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "17",
    r: "1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "17",
    r: "1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M12,26H6c-2.2,0-4-1.8-4-4V12c0-2.2,1.8-4,4-4h8v2H6c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h6V26z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmWatsonAssistant.propTypes = iconPropTypes;
}
var IbmWatsonDiscovery = /*#__PURE__*/React.forwardRef(function IbmWatsonDiscovery(_ref22, ref) {
  var children = _ref22.children,
      _ref22$size = _ref22.size,
      size = _ref22$size === void 0 ? 16 : _ref22$size,
      rest = _objectWithoutProperties(_ref22, _excluded22);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17H14V19H6z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "18",
    r: "1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "14",
    r: "1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13H10V15H2zM6 9H14V11H6z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "10",
    r: "1"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.6l-7.4-7.4c1.5-2,2.4-4.5,2.4-7.2c0-6.6-5.4-12-12-12C9.7,2,6.6,3.3,4.3,5.8l1.5,1.4C7.6,5.1,10.2,4,13,4 c5.5,0,10,4.5,10,10s-4.5,10-10,10c-3,0-5.8-1.3-7.7-3.6l-1.5,1.3C6,24.4,9.4,26,13,26c3.2,0,6.1-1.3,8.3-3.3l7.3,7.3L30,28.6z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmWatsonDiscovery.propTypes = iconPropTypes;
}
var IbmWatsonKnowledgeCatalog = /*#__PURE__*/React.forwardRef(function IbmWatsonKnowledgeCatalog(_ref23, ref) {
  var children = _ref23.children,
      _ref23$size = _ref23.size,
      size = _ref23$size === void 0 ? 16 : _ref23$size,
      rest = _objectWithoutProperties(_ref23, _excluded23);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27.2L20.4 24.6 19 26 23 30 30 23 28.6 21.6zM12 18H20V20H12zM12 13H20V15H12zM12 8H20V10H12z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H6v-4h2v-2H6v-5h2v-2H6v-5h2V8H6V4h18v16h2V4c0-1.1-0.9-2-2-2H6C4.9,2,4,2.9,4,4v4H2v2h2v5H2v2h2v5H2v2h2v4 c0,1.1,0.9,2,2,2h10V28z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmWatsonKnowledgeCatalog.propTypes = iconPropTypes;
}
var IbmWatsonKnowledgeStudio = /*#__PURE__*/React.forwardRef(function IbmWatsonKnowledgeStudio(_ref24, ref) {
  var children = _ref24.children,
      _ref24$size = _ref24.size,
      size = _ref24$size === void 0 ? 16 : _ref24$size,
      rest = _objectWithoutProperties(_ref24, _excluded24);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25H27V27H20zM22 29H25V31H22zM27 23h-2c0-1.1.4-2 1.2-2.8l.5-.5c.8-.8 1.3-2 1.3-3.2 0-2.5-2-4.5-4.5-4.5S19 14 19 16.5c0 1.2.5 2.3 1.3 3.2l.5.5C21.6 21 22 21.9 22 23h-2c0-.5-.2-1-.6-1.4l-.5-.5c-1.2-1.2-1.9-2.9-1.9-4.6 0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5c0 1.7-.7 3.4-1.9 4.6l-.5.5C27.2 22 27 22.5 27 23zM6 22H14V24H6z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "19",
    r: "1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H9V20H6zM6 14H13V16H6zM10 10H17V12H10z"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "11",
    r: "1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H20V8H16z"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "7",
    r: "1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H10V8H6z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H4V4l18,0v4h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h14V28z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmWatsonKnowledgeStudio.propTypes = iconPropTypes;
}
var IbmWatsonLanguageTranslator = /*#__PURE__*/React.forwardRef(function IbmWatsonLanguageTranslator(_ref25, ref) {
  var children = _ref25.children,
      _ref25$size = _ref25.size,
      size = _ref25$size === void 0 ? 16 : _ref25$size,
      rest = _objectWithoutProperties(_ref25, _excluded25);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28h-3c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h3V28zM28 30h2.2l-4.6-11h-2.2l-4.6 11H21l.8-2h5.3L28 30zM22.7 26l1.8-4.4 1.8 4.4H22.7zM28 15h-2v-4c0-2.8-2.2-5-5-5h-4V4h4c3.9 0 7 3.1 7 7V15zM14 5V3H9V1H7v2H2v2h8.2C10 5.9 9.4 7.5 8 9 7.4 8.3 6.9 7.6 6.6 7H4.3c.4 1 1.1 2.2 2.1 3.3C5.6 11 4.4 11.6 3 12.1L3.7 14c1.8-.7 3.2-1.5 4.3-2.3 1.1.9 2.5 1.7 4.3 2.3l.7-1.9c-1.4-.5-2.6-1.2-3.5-1.8 1.9-2 2.5-4.1 2.7-5.3H14z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmWatsonLanguageTranslator.propTypes = iconPropTypes;
}
var IbmWatsonMachineLearning = /*#__PURE__*/React.forwardRef(function IbmWatsonMachineLearning(_ref26, ref) {
  var children = _ref26.children,
      _ref26$size = _ref26.size,
      size = _ref26$size === void 0 ? 16 : _ref26$size,
      rest = _objectWithoutProperties(_ref26, _excluded26);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 22.5c-1-2-1.6-4.2-1.6-6.5C2 8.3 8.3 2 16 2v2C9.4 4 4 9.4 4 16c0 2 .5 3.8 1.4 5.5L3.6 22.5zM28 16c0 6.6-5.4 12-12 12-2.9 0-5.6-1-7.7-2.8l5.7-5.7L12.6 18l-6.5 6.5c-.4.4-.4 1 0 1.4C8.7 28.5 12.3 30 16 30c7.7 0 14-6.3 14-14H28z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M18,25c-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.6-0.4-0.6-0.8l-0.7-5l2-0.3l0.4,3.3l2.2-1.7V15c0-0.3,0.1-0.5,0.3-0.7l3.2-3.2 c0.9-0.9,1.5-2.2,1.5-3.5V6l-1.5,0c-1.3,0-2.6,0.5-3.5,1.5l-3.2,3.2C17.5,10.9,17.3,11,17,11h-5.5l-1.7,2.2l3.3,0.4l-0.3,2l-5-0.7 c-0.4,0-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l3-4C10.4,9.1,10.7,9,11,9h5.6l3-3c1.3-1.3,3.1-2,4.9-2H26c1.1,0,2,0.9,2,2v1.5 c0,1.9-0.7,3.6-2,4.9l-3,3V21c0,0.3-0.1,0.6-0.4,0.8l-4,3C18.4,24.9,18.2,25,18,25z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmWatsonMachineLearning.propTypes = iconPropTypes;
}
var IbmWatsonNaturalLanguageClassifier = /*#__PURE__*/React.forwardRef(function IbmWatsonNaturalLanguageClassifier(_ref27, ref) {
  var children = _ref27.children,
      _ref27$size = _ref27.size,
      size = _ref27$size === void 0 ? 16 : _ref27$size,
      rest = _objectWithoutProperties(_ref27, _excluded27);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h1v4h-3v2h8v-2h-3v-4H28zM24 4h4v6h-4V4zM21 22.4L19.6 21 16 24.6 12.4 21 11 22.4 14.6 26 11 29.6 12.4 31 16 27.4 19.6 31 21 29.6 17.4 26zM12 18L15 18 15 21 17 21 17 18 20 18 20 16 12 16zM10 12V4c0-1.1-.9-2-2-2H3v2h5v2H4C2.9 6 2 6.9 2 8v2c0 1.1.9 2 2 2h1v4H2v2h8v-2H7v-4H10zM4 8h4v2H4V8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmWatsonNaturalLanguageClassifier.propTypes = iconPropTypes;
}
var IbmWatsonNaturalLanguageUnderstanding = /*#__PURE__*/React.forwardRef(function IbmWatsonNaturalLanguageUnderstanding(_ref28, ref) {
  var children = _ref28.children,
      _ref28$size = _ref28.size,
      size = _ref28$size === void 0 ? 16 : _ref28$size,
      rest = _objectWithoutProperties(_ref28, _excluded28);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M6 23H11V25H6zM6 19H11V21H6z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M13 30H4c-1.1 0-2-.9-2-2V17c0-1.1.9-2 2-2h9c1.1 0 2 .9 2 2v11C15 29.1 14.1 30 13 30zM4 17v11h9V17H4zM19 2H27V4H19zM22 6H30V8H22zM22 10H30V12H22zM19 14H27V16H19zM22 18H30V20H22zM12 1l-1.4 1.4L13.2 5H4C2.9 5 2 5.9 2 7v5h2V7h9.2l-2.6 2.6L12 11l5-5L12 1z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmWatsonNaturalLanguageUnderstanding.propTypes = iconPropTypes;
}
var IbmWatsonOpenscale = /*#__PURE__*/React.forwardRef(function IbmWatsonOpenscale(_ref29, ref) {
  var children = _ref29.children,
      _ref29$size = _ref29.size,
      size = _ref29$size === void 0 ? 16 : _ref29$size,
      rest = _objectWithoutProperties(_ref29, _excluded29);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S5.7 28 4 28zM4 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S4.6 24 4 24zM28 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S29.7 28 28 28zM28 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S28.6 24 28 24zM22.4 4.4l-.9 1.8C26.1 8.4 29 13 29 18c0 .7-.1 1.4-.2 2.1l2 .3c.1-.8.2-1.6.2-2.5C31 12.2 27.6 6.9 22.4 4.4zM16 7c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S17.7 7 16 7zM16 3c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S16.6 3 16 3z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5,13.6l-1-1.7L17,16.3V9h-2v7.2L6.2,11c-0.5-0.3-1.1-0.1-1.4,0.3s-0.1,1.1,0.3,1.4L14,18l-6.2,3.6l1,1.7l6.2-3.6V30 c0,0.6,0.4,1,1,1s1-0.4,1-1V19.8l6.2,3.7l1-1.7L18,18L25.5,13.6z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmWatsonOpenscale.propTypes = iconPropTypes;
}
var IbmWatsonOrders = /*#__PURE__*/React.forwardRef(function IbmWatsonOrders(_ref30, ref) {
  var children = _ref30.children,
      _ref30$size = _ref30.size,
      size = _ref30$size === void 0 ? 16 : _ref30$size,
      rest = _objectWithoutProperties(_ref30, _excluded30);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13h-2v-2c0-2.8-2.2-5-5-5h-3V4h3c3.9 0 7 3.1 7 7V13zM22 20H25V22H22zM22 24H25V26H22z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30h-5v-2h5V18h-7v9c0 1.7-1.3 3-3 3s-3-1.3-3-3v-3h2v3c0 .6.4 1 1 1s1-.4 1-1V16h11v12C29 29.1 28.1 30 27 30zM12 28h-1c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h1V28zM11 10v2h3c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4C2.9 2 2 2.9 2 4v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4V4h10v6H11z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmWatsonOrders.propTypes = iconPropTypes;
}
var IbmWatsonQuery = /*#__PURE__*/React.forwardRef(function IbmWatsonQuery(_ref31, ref) {
  var children = _ref31.children,
      _ref31$size = _ref31.size,
      size = _ref31$size === void 0 ? 16 : _ref31$size,
      rest = _objectWithoutProperties(_ref31, _excluded31);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M22,24c-0.2,0-0.3,0-0.5,0L18.2,18c0.5-0.5,0.8-1.2,0.8-2c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,0.8,0.3,1.5,0.8,2L10.5,24 c-0.2,0-0.3,0-0.5,0c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.8-0.3-1.5-0.8-2l3.3-6.1c0.2,0,0.3,0,0.5,0s0.3,0,0.5,0l3.3,6.1 c-0.5,0.5-0.8,1.2-0.8,2c0,1.7,1.3,3,3,3s3-1.3,3-3S23.7,24,22,24z M16,15c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S15.4,15,16,15z M10,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,28,10,28z M22,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,28,22,28z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H9v-2H8.5C6,20,4,18,4,15.5 c0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5 c0,2.5-2,4.5-4.5,4.5H23v2h0.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmWatsonQuery.propTypes = iconPropTypes;
}
var IbmWatsonSpeechToText = /*#__PURE__*/React.forwardRef(function IbmWatsonSpeechToText(_ref32, ref) {
  var children = _ref32.children,
      _ref32$size = _ref32.size,
      size = _ref32$size === void 0 ? 16 : _ref32$size,
      rest = _objectWithoutProperties(_ref32, _excluded32);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4v-6h10v6h-3v2h3c1.1 0 2-.9 2-2v-6C16 18.9 15.1 18 14 18zM19 26h2c3.9 0 7-3.1 7-7v-2h-2v2c0 2.8-2.2 5-5 5h-2V26zM18 11H24V13H18zM18 7H30V9H18zM18 3H30V5H18zM4 14h2v-2c0-2.8 2.2-5 5-5h4V5h-4c-3.9 0-7 3.1-7 7V14z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmWatsonSpeechToText.propTypes = iconPropTypes;
}
var IbmWatsonStudio = /*#__PURE__*/React.forwardRef(function IbmWatsonStudio(_ref33, ref) {
  var children = _ref33.children,
      _ref33$size = _ref33.size,
      size = _ref33$size === void 0 ? 16 : _ref33$size,
      rest = _objectWithoutProperties(_ref33, _excluded33);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5S27.8 21 25 21zM25 13c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3S26.7 13 25 13zM14 11V6c0-1.1-.9-2-2-2h-2v2h2v5c0 2.1 1.1 3.9 2.7 5-1.6 1.1-2.7 2.9-2.7 5v5h-2v2h2c1.1 0 2-.9 2-2v-5c0-2.2 1.8-4 4-4v-2C15.8 15 14 13.2 14 11zM2 30v-6h6v6H2zM4 26v2h2v-2H4zM2 19v-6h6v6H2zM4 15v2h2v-2H4zM2 8V2h6v6H2zM4 4v2h2V4H4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmWatsonStudio.propTypes = iconPropTypes;
}
var IbmWatsonTextToSpeech = /*#__PURE__*/React.forwardRef(function IbmWatsonTextToSpeech(_ref34, ref) {
  var children = _ref34.children,
      _ref34$size = _ref34.size,
      size = _ref34$size === void 0 ? 16 : _ref34$size,
      rest = _objectWithoutProperties(_ref34, _excluded34);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M13 26h-2c-3.9 0-7-3.1-7-7v-2h2v2c0 2.8 2.2 5 5 5h2V26zM18 18h10c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2h-2.4l-1.7 3-1.7-1 2.3-4H28v-6H18v6h3v2h-3c-1.1 0-2-.9-2-2v-6C16 18.9 16.9 18 18 18zM28 14h-2v-2c0-2.8-2.2-5-5-5h-4V5h4c3.9 0 7 3.1 7 7V14zM2 11H8V13H2zM2 7H14V9H2zM2 3H14V5H2z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmWatsonTextToSpeech.propTypes = iconPropTypes;
}
var IbmWatsonToneAnalyzer = /*#__PURE__*/React.forwardRef(function IbmWatsonToneAnalyzer(_ref35, ref) {
  var children = _ref35.children,
      _ref35$size = _ref35.size,
      size = _ref35$size === void 0 ? 16 : _ref35$size,
      rest = _objectWithoutProperties(_ref35, _excluded35);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9,10c-0.6-0.6-1.5-1-2.4-1s-1.8,0.4-2.4,1l-1.4-1.4c1-1,2.4-1.6,3.8-1.6s2.9,0.6,3.8,1.6L23.9,10z"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "5",
    r: "1"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "5",
    r: "1"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0l13 0c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2h-3.5l-1.7 3L21 16l2.3-4H28V2H15v10h5v2h-5c-1.1 0-2-.9-2-2V2C13 .9 13.9 0 15 0zM20 19v6c0 .6-.4 1-1 1h-5v2h5c1.7 0 3-1.3 3-3v-6H20zM15.4 20.4c-.8 1-2.1 1.6-3.4 1.6s-2.6-.6-3.4-1.6L7 21.6c1.2 1.4 3 2.4 5 2.4s3.8-.9 5-2.4L15.4 20.4z"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "15.5",
    cy: "17.5",
    r: "1.5"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "8.5",
    cy: "17.5",
    r: "1.5"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1,26H5c-0.6,0-1-0.4-1-1V14c0-0.6,0.4-1,1-1h5v-2H5c-1.7,0-3,1.3-3,3v11c0,1.7,1.3,3,3,3h4l2.3,4l1.7-1L10.1,26z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmWatsonToneAnalyzer.propTypes = iconPropTypes;
}
var IbmZCloudModStack = /*#__PURE__*/React.forwardRef(function IbmZCloudModStack(_ref36, ref) {
  var children = _ref36.children,
      _ref36$size = _ref36.size,
      size = _ref36$size === void 0 ? 16 : _ref36$size,
      rest = _objectWithoutProperties(_ref36, _excluded36);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M18.496,27.386L16,28.842L5,22.426v-5.852l10.016-5.843C15.308,10.897,15.641,11,16,11c1.104,0,2-0.896,2-2s-0.896-2-2-2 s-2,0.896-2,2c0,0.003,0.001,0.005,0.001,0.008L3.496,15.136C3.189,15.315,3,15.645,3,16v7c0,0.355,0.189,0.685,0.496,0.864l12,7 C15.652,30.955,15.826,31,16,31s0.348-0.045,0.504-0.136l3-1.75L18.496,27.386z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M28.504,8.136l-3-1.75l-1.008,1.728L27,9.574v12.852l-4.593,2.679l-10.409-6.093C11.999,19.007,12,19.004,12,19 c0-1.104-0.896-2-2-2s-2,0.896-2,2s0.896,2,2,2c0.358,0,0.69-0.102,0.981-0.267l10.92,6.393c0.156,0.091,0.331,0.137,0.505,0.137 c0.174,0,0.348-0.045,0.504-0.136l5.594-3.263C28.811,23.685,29,23.355,29,23V9C29,8.645,28.811,8.315,28.504,8.136z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17.277V5.5c0-0.355-0.189-0.685-0.496-0.864l-6-3.5C16.348,1.045,16.174,1,16,1s-0.348,0.045-0.504,0.136l-12,7 C3.189,8.315,3,8.645,3,9v2.999h2V9.574l11-6.417l5,2.917v11.203c-0.595,0.347-1,0.984-1,1.723c0,1.104,0.896,2,2,2s2-0.896,2-2 C24,18.262,23.595,17.624,23,17.277z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmZCloudModStack.propTypes = iconPropTypes;
}
var IbmZCloudProvisioning = /*#__PURE__*/React.forwardRef(function IbmZCloudProvisioning(_ref37, ref) {
  var children = _ref37.children,
      _ref37$size = _ref37.size,
      size = _ref37$size === void 0 ? 16 : _ref37$size,
      rest = _objectWithoutProperties(_ref37, _excluded37);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17H14V21H10zM17 10H21V14H17zM17 17H21V21H17z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmZCloudProvisioning.propTypes = iconPropTypes;
}
var IbmZOsPackageManager = /*#__PURE__*/React.forwardRef(function IbmZOsPackageManager(_ref38, ref) {
  var children = _ref38.children,
      _ref38$size = _ref38.size,
      size = _ref38$size === void 0 ? 16 : _ref38$size,
      rest = _objectWithoutProperties(_ref38, _excluded38);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9v10.172l-2.586-2.586L11 18l5 5 5-5-1.414-1.414L17 19.172V9H15zM19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IbmZOsPackageManager.propTypes = iconPropTypes;
}
var WatsonHealthICa_2D = /*#__PURE__*/React.forwardRef(function WatsonHealthICa_2D(_ref39, ref) {
  var children = _ref39.children,
      _ref39$size = _ref39.size,
      size = _ref39$size === void 0 ? 16 : _ref39$size,
      rest = _objectWithoutProperties(_ref39, _excluded39);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H22a2.0023 2.0023 0 012 2V22A2.0023 2.0023 0 0122 24zM10 10V22H22V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2zM2 21L2 30 11 30 11 28 4 28 4 21 2 21zM30 11L30 2 21 2 21 4 28 4 28 11 30 11zM21 30L30 30 30 21 28 21 28 28 21 28 21 30z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthICa_2D.propTypes = iconPropTypes;
}
var IceAccretion = /*#__PURE__*/React.forwardRef(function IceAccretion(_ref40, ref) {
  var children = _ref40.children,
      _ref40$size = _ref40.size,
      size = _ref40$size === void 0 ? 16 : _ref40$size,
      rest = _objectWithoutProperties(_ref40, _excluded40);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2A2 2 0 002 4V20l1 2 1-2V4H8V14l1 2 1-2V2zM28 2H14v8l1 2 1-2V4h2V17l1 2 1-2V4h4V14l1 2 1-2V4h2V24l1 2 1-2V4A2 2 0 0028 2zM14 28L13 30 12 28 12 16 14 16 14 28z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26L23 28 22 26 22 20 24 20 24 26zM8 24L7 26 6 24 6 18 8 18 8 24z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IceAccretion.propTypes = iconPropTypes;
}
var IceVision = /*#__PURE__*/React.forwardRef(function IceVision(_ref41, ref) {
  var children = _ref41.children,
      _ref41$size = _ref41.size,
      size = _ref41$size === void 0 ? 16 : _ref41$size,
      rest = _objectWithoutProperties(_ref41, _excluded41);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14L19 21 20 23 21 21 21 14 19 14zM17 14H13a2 2 0 00-2 2v4l1 2 1-2V16h2v7l1 2 1-2z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IceVision.propTypes = iconPropTypes;
}
var QID = /*#__PURE__*/React.forwardRef(function QID(_ref42, ref) {
  var children = _ref42.children,
      _ref42$size = _ref42.size,
      size = _ref42$size === void 0 ? 16 : _ref42$size,
      rest = _objectWithoutProperties(_ref42, _excluded42);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9H12V11H10zM18 23H14V9h4a4 4 0 014 4v6A4 4 0 0118 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H16zM10 13H12V23H10z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  QID.propTypes = iconPropTypes;
}
var IdManagement = /*#__PURE__*/React.forwardRef(function IdManagement(_ref43, ref) {
  var children = _ref43.children,
      _ref43$size = _ref43.size,
      size = _ref43$size === void 0 ? 16 : _ref43$size,
      rest = _objectWithoutProperties(_ref43, _excluded43);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20H9a3 3 0 00-3 3v2H8V23a1 1 0 011-1h6a1 1 0 011 1v2h2V23A3 3 0 0015 20zM12 19a4 4 0 10-4-4A4 4 0 0012 19zm0-6a2 2 0 11-2 2A2 2 0 0112 13z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M28,19v9H4V8H16V6H4A2,2,0,0,0,2,8V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19H26V21H20zM22 23H26V25H22zM32 10V8H29.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0026 4.1011V2H24V4.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0020.1011 8H18v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0024 13.8989V16h2V13.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0029.8989 10zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0125 12z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IdManagement.propTypes = iconPropTypes;
}
var Idea = /*#__PURE__*/React.forwardRef(function Idea(_ref44, ref) {
  var children = _ref44.children,
      _ref44$size = _ref44.size,
      size = _ref44$size === void 0 ? 16 : _ref44$size,
      rest = _objectWithoutProperties(_ref44, _excluded44);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM16 2A10 10 0 006 12a9.19 9.19 0 003.46 7.62c1 .93 1.54 1.46 1.54 2.38h2c0-1.84-1.11-2.87-2.19-3.86A7.2 7.2 0 018 12a8 8 0 0116 0 7.2 7.2 0 01-2.82 6.14c-1.07 1-2.18 2-2.18 3.86h2c0-.92.53-1.45 1.54-2.39A9.18 9.18 0 0026 12 10 10 0 0016 2z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Idea.propTypes = iconPropTypes;
}
var Identification = /*#__PURE__*/React.forwardRef(function Identification(_ref45, ref) {
  var children = _ref45.children,
      _ref45$size = _ref45.size,
      size = _ref45$size === void 0 ? 16 : _ref45$size,
      rest = _objectWithoutProperties(_ref45, _excluded45);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10H13V12H6zM6 14H10V16H6zM23 18H17a3 3 0 00-3 3v2h2V21a1 1 0 011-1h6a1 1 0 011 1v2h2V21A3 3 0 0023 18zM20 17a4 4 0 10-4-4A4 4 0 0020 17zm0-6a2 2 0 11-2 2A2 2 0 0120 11z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Identification.propTypes = iconPropTypes;
}
var Image = /*#__PURE__*/React.forwardRef(function Image(_ref46, ref) {
  var children = _ref46.children,
      _ref46$size = _ref46.size,
      size = _ref46$size === void 0 ? 16 : _ref46$size,
      rest = _objectWithoutProperties(_ref46, _excluded46);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M19,14a3,3,0,1,0-3-3A3,3,0,0,0,19,14Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,19,10Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,22H6V20l5-5,5.59,5.59a2,2,0,0,0,2.82,0L21,19l5,5Zm0-4.83-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17l-5.59-5.59a2,2,0,0,0-2.82,0L6,17.17V6H26Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Image.propTypes = iconPropTypes;
}
var ImageCopy = /*#__PURE__*/React.forwardRef(function ImageCopy(_ref47, ref) {
  var children = _ref47.children,
      _ref47$size = _ref47.size,
      size = _ref47$size === void 0 ? 16 : _ref47$size,
      rest = _objectWithoutProperties(_ref47, _excluded47);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22H2V4A2.0023 2.0023 0 014 2H22V4H4zM21 17a3 3 0 10-3-3A3.0033 3.0033 0 0021 17zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0121 13z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M28,7H9A2.0025,2.0025,0,0,0,7,9V28a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V9A2.0025,2.0025,0,0,0,28,7Zm0,21H9v-6l4-3.9971,5.5859,5.586a2,2,0,0,0,2.8282,0L23,22.0034,28,27Zm0-3.8281-3.5859-3.586a2,2,0,0,0-2.8282,0L20,22.1719l-5.5859-5.586a2,2,0,0,0-2.8282,0L9,19.1719V9H28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ImageCopy.propTypes = iconPropTypes;
}
var ImageMedical = /*#__PURE__*/React.forwardRef(function ImageMedical(_ref48, ref) {
  var children = _ref48.children,
      _ref48$size = _ref48.size,
      size = _ref48$size === void 0 ? 16 : _ref48$size,
      rest = _objectWithoutProperties(_ref48, _excluded48);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6V26H6V6H26m0-2H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16L22 14 17 14 17 12 20 12 20 10 17 10 17 8 15 8 15 10 12 10 12 12 15 12 15 14 10 14 10 16 15 16 15 18 10 18 10 20 15 20 15 22 12 22 12 24 20 24 20 22 17 22 17 20 22 20 22 18 17 18 17 16 22 16z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ImageMedical.propTypes = iconPropTypes;
}
var ImageReference = /*#__PURE__*/React.forwardRef(function ImageReference(_ref49, ref) {
  var children = _ref49.children,
      _ref49$size = _ref49.size,
      size = _ref49$size === void 0 ? 16 : _ref49$size,
      rest = _objectWithoutProperties(_ref49, _excluded49);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM19 14a3 3 0 10-3-3A3 3 0 0019 14zm0-4a1 1 0 11-1 1A1 1 0 0119 10z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V16H6V6H26V21.17l-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17,11.8308,13l-1.4151,1.4155L14,18l2.59,2.59a2,2,0,0,0,2.82,0L21,19l5,5v2H16v2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ImageReference.propTypes = iconPropTypes;
}
var ImageSearch = /*#__PURE__*/React.forwardRef(function ImageSearch(_ref50, ref) {
  var children = _ref50.children,
      _ref50$size = _ref50.size,
      size = _ref50$size === void 0 ? 16 : _ref50$size,
      rest = _objectWithoutProperties(_ref50, _excluded50);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14a5.99 5.99 0 00-4.885 9.4712L14 28.5859 15.4141 30l5.1147-5.1147A5.9971 5.9971 0 1024 14zm0 10a4 4 0 114-4A4.0045 4.0045 0 0124 24zM17 12a3 3 0 10-3-3A3.0033 3.0033 0 0017 12zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0117 8z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M12,24H4V17.9966L9,13l5.5859,5.5859L16,17.168l-5.5859-5.5855a2,2,0,0,0-2.8282,0L4,15.168V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.002,2.002,0,0,0,2,4V24a2.0023,2.0023,0,0,0,2,2h8Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ImageSearch.propTypes = iconPropTypes;
}
var ImageSearchAlt = /*#__PURE__*/React.forwardRef(function ImageSearchAlt(_ref51, ref) {
  var children = _ref51.children,
      _ref51$size = _ref51.size,
      size = _ref51$size === void 0 ? 16 : _ref51$size,
      rest = _objectWithoutProperties(_ref51, _excluded51);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16a5.9908,5.9908,0,0,0,9.4712,4.8853L24.5859,26,26,24.5859l-5.115-5.1147A5.997,5.997,0,1,0,10,16Zm2,0a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M29,7H22.54L20.83,4.45A.9946.9946,0,0,0,20,4H12a.9946.9946,0,0,0-.83.45L9.46,7H3A1.0031,1.0031,0,0,0,2,8V25a1.0031,1.0031,0,0,0,1,1h9V24H4V9h6a.9946.9946,0,0,0,.83-.45L12.54,6h6.92l1.71,2.55A.9946.9946,0,0,0,22,9h6V21h2V8A1.0031,1.0031,0,0,0,29,7Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ImageSearchAlt.propTypes = iconPropTypes;
}
var WatsonHealthImageAvailabilityLocal = /*#__PURE__*/React.forwardRef(function WatsonHealthImageAvailabilityLocal(_ref52, ref) {
  var children = _ref52.children,
      _ref52$size = _ref52.size,
      size = _ref52$size === void 0 ? 16 : _ref52$size,
      rest = _objectWithoutProperties(_ref52, _excluded52);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M16,18c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S18.8,18,16,18z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0 c0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13 c0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthImageAvailabilityLocal.propTypes = iconPropTypes;
}
var WatsonHealthImageAvailabilityRetrieving = /*#__PURE__*/React.forwardRef(function WatsonHealthImageAvailabilityRetrieving(_ref53, ref) {
  var children = _ref53.children,
      _ref53$size = _ref53.size,
      size = _ref53$size === void 0 ? 16 : _ref53$size,
      rest = _objectWithoutProperties(_ref53, _excluded53);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13L11.4 11.6 15 15.2 15 2 17 2 17 15.2 20.6 11.6 22 13 16 19z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M20,2.8V5c3,1.5,5,4.5,5,8c0,2-0.6,3.8-1.8,5.4c0,0-0.2,0.3-0.3,0.4L16,26.9l-6.9-8.1c-0.1-0.1-0.3-0.4-0.3-0.4 C7.6,16.8,7,15,7,13c0-3.5,2-6.6,5-8V2.8C7.9,4.4,5,8.3,5,13c0,2.4,0.8,4.7,2.2,6.6c0,0,0.3,0.4,0.3,0.5L16,30l8.4-10 c0-0.1,0.3-0.4,0.3-0.4l0,0c1.4-1.9,2.2-4.2,2.2-6.6C27,8.3,24.1,4.4,20,2.8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthImageAvailabilityRetrieving.propTypes = iconPropTypes;
}
var WatsonHealthImageAvailabilityUnavailable = /*#__PURE__*/React.forwardRef(function WatsonHealthImageAvailabilityUnavailable(_ref54, ref) {
  var children = _ref54.children,
      _ref54$size = _ref54.size,
      size = _ref54$size === void 0 ? 16 : _ref54$size,
      rest = _objectWithoutProperties(_ref54, _excluded54);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "20.5",
    r: "1.5"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M17,17h-2v-4h2c1.1,0,2-0.9,2-2s-0.9-2-2-2h-2c-1.1,0-2,0.9-2,2v0.5h-2V11c0-2.2,1.8-4,4-4h2c2.2,0,4,1.8,4,4s-1.8,4-4,4V17 z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0 c0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13 c0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthImageAvailabilityUnavailable.propTypes = iconPropTypes;
}
var ImageService = /*#__PURE__*/React.forwardRef(function ImageService(_ref55, ref) {
  var children = _ref55.children,
      _ref55$size = _ref55.size,
      size = _ref55$size === void 0 ? 16 : _ref55$size,
      rest = _objectWithoutProperties(_ref55, _excluded55);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4H15V12H13zM9 4H11V12H9zM21 12H19a2.0021 2.0021 0 01-2-2V6a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0121 12zM19 6v4h2V6zM21 14H23V22H21zM9 14H11V22H9zM17 22H15a2.0021 2.0021 0 01-2-2V16a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0117 22zm-2-6v4h2V16z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ImageService.propTypes = iconPropTypes;
}
var ImportExport = /*#__PURE__*/React.forwardRef(function ImportExport(_ref56, ref) {
  var children = _ref56.children,
      _ref56$size = _ref56.size,
      size = _ref56$size === void 0 ? 16 : _ref56$size,
      rest = _objectWithoutProperties(_ref56, _excluded56);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24v4H4V24H2v4l.0076-.0049A1.9977 1.9977 0 004 30H28a2 2 0 002-2h0V24zM27.6 14.6L24 18.2 24 4 22 4 22 18.2 18.4 14.6 17 16 23 22 29 16 27.6 14.6zM9 4L3 10 4.4 11.4 8 7.8 8 22 10 22 10 7.8 13.6 11.4 15 10 9 4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ImportExport.propTypes = iconPropTypes;
}
var ImproveRelevance = /*#__PURE__*/React.forwardRef(function ImproveRelevance(_ref57, ref) {
  var children = _ref57.children,
      _ref57$size = _ref57.size,
      size = _ref57$size === void 0 ? 16 : _ref57$size,
      rest = _objectWithoutProperties(_ref57, _excluded57);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26.59L19.41 24 18 25.41 22 29.41 30 21.41 28.59 20 22 26.59z"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16A12,12,0,1,0,16,28V26A10,10,0,1,1,26,16Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ImproveRelevance.propTypes = iconPropTypes;
}
var InProgress = /*#__PURE__*/React.forwardRef(function InProgress(_ref58, ref) {
  var children = _ref58.children,
      _ref58$size = _ref58.size,
      size = _ref58$size === void 0 ? 16 : _ref58$size,
      rest = _objectWithoutProperties(_ref58, _excluded58);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm0,26A12,12,0,0,1,16,4V16l8.4812,8.4814A11.9625,11.9625,0,0,1,16,28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  InProgress.propTypes = iconPropTypes;
}
var InProgressError = /*#__PURE__*/React.forwardRef(function InProgressError(_ref59, ref) {
  var children = _ref59.children,
      _ref59$size = _ref59.size,
      size = _ref59$size === void 0 ? 16 : _ref59$size,
      rest = _objectWithoutProperties(_ref59, _excluded59);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M14,2a12,12,0,1,0,2,23.8193v-2.021A10,10,0,1,1,14,4V14l4.343,4.3433A7.9751,7.9751,0,0,1,24,16h1.8193A11.93,11.93,0,0,0,14,2Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  InProgressError.propTypes = iconPropTypes;
}
var InProgressWarning = /*#__PURE__*/React.forwardRef(function InProgressWarning(_ref60, ref) {
  var children = _ref60.children,
      _ref60$size = _ref60.size,
      size = _ref60$size === void 0 ? 16 : _ref60$size,
      rest = _objectWithoutProperties(_ref60, _excluded60);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M18.746,22.7993A9.999,9.999,0,1,1,14,4V14l6.0971,6.0972,1.22-2.44A2.9849,2.9849,0,0,1,24,16h1.8193A11.993,11.993,0,1,0,14,26a11.9337,11.9337,0,0,0,3.3939-.4966Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  InProgressWarning.propTypes = iconPropTypes;
}
var Incomplete = /*#__PURE__*/React.forwardRef(function Incomplete(_ref61, ref) {
  var children = _ref61.children,
      _ref61$size = _ref61.size,
      size = _ref61$size === void 0 ? 16 : _ref61$size,
      rest = _objectWithoutProperties(_ref61, _excluded61);

  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
      d: "M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2ZM8,4a4.0045,4.0045,0,0,1,4,4H4A4.0045,4.0045,0,0,1,8,4Z"
    })), children);
  }

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7642 6.8593l1.2851-1.5315A13.976 13.976 0 0020.8672 2.887l-.6836 1.8776A11.9729 11.9729 0 0123.7642 6.8593zM27.81 14l1.9677-.4128A13.8888 13.8888 0 0028.14 9.0457L26.4087 10A12.52 12.52 0 0127.81 14zM20.1836 27.2354l.6836 1.8776a13.976 13.976 0 004.1821-2.4408l-1.2851-1.5315A11.9729 11.9729 0 0120.1836 27.2354zM26.4087 22L28.14 23a14.14 14.14 0 001.6382-4.5872L27.81 18.0659A12.1519 12.1519 0 0126.4087 22zM16 30V2a14 14 0 000 28z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Incomplete.propTypes = iconPropTypes;
}
var IncompleteCancel = /*#__PURE__*/React.forwardRef(function IncompleteCancel(_ref62, ref) {
  var children = _ref62.children,
      _ref62$size = _ref62.size,
      size = _ref62$size === void 0 ? 16 : _ref62$size,
      rest = _objectWithoutProperties(_ref62, _excluded62);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M30 21.41L28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25 30 21.41zM14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IncompleteCancel.propTypes = iconPropTypes;
}
var IncompleteError = /*#__PURE__*/React.forwardRef(function IncompleteError(_ref63, ref) {
  var children = _ref63.children,
      _ref63$size = _ref63.size,
      size = _ref63$size === void 0 ? 16 : _ref63$size,
      rest = _objectWithoutProperties(_ref63, _excluded63);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IncompleteError.propTypes = iconPropTypes;
}
var IncompleteWarning = /*#__PURE__*/React.forwardRef(function IncompleteWarning(_ref64, ref) {
  var children = _ref64.children,
      _ref64$size = _ref64.size,
      size = _ref64$size === void 0 ? 16 : _ref64$size,
      rest = _objectWithoutProperties(_ref64, _excluded64);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IncompleteWarning.propTypes = iconPropTypes;
}
var IncreaseLevel = /*#__PURE__*/React.forwardRef(function IncreaseLevel(_ref65, ref) {
  var children = _ref65.children,
      _ref65$size = _ref65.size,
      size = _ref65$size === void 0 ? 16 : _ref65$size,
      rest = _objectWithoutProperties(_ref65, _excluded65);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M23 4L18 7.75 18 14.25 15 12 10 15.75 10 22.25 7 20 2 23.75 2 30 4 30 4 24.75 7 22.5 10 24.75 10 30 12 30 12 16.75 15 14.5 18 16.75 18 30 20 30 20 8.75 23 6.5 26 8.75 26 30 28 30 28 7.75 23 4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IncreaseLevel.propTypes = iconPropTypes;
}
var Industry = /*#__PURE__*/React.forwardRef(function Industry(_ref66, ref) {
  var children = _ref66.children,
      _ref66$size = _ref66.size,
      size = _ref66$size === void 0 ? 16 : _ref66$size,
      rest = _objectWithoutProperties(_ref66, _excluded66);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M29.53,6.15a1,1,0,0,0-1,0L20,10.38V7a1,1,0,0,0-1.45-.89L10,10.38V3A1,1,0,0,0,9,2H3A1,1,0,0,0,2,3V28H30V7A1,1,0,0,0,29.53,6.15ZM22,26H18V19h4Zm6,0H24V18a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1v8H4V4H8v9.62l10-5v5l10-5Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Industry.propTypes = iconPropTypes;
}
var Information = /*#__PURE__*/React.forwardRef(function Information(_ref67, ref) {
  var children = _ref67.children,
      _ref67$size = _ref67.size,
      size = _ref67$size === void 0 ? 16 : _ref67$size,
      rest = _objectWithoutProperties(_ref67, _excluded67);

  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
      d: "M8.5 11L8.5 6.5 6.5 6.5 6.5 7.5 7.5 7.5 7.5 11 6 11 6 12 10 12 10 11zM8 3.5c-.4 0-.8.3-.8.8S7.6 5 8 5c.4 0 .8-.3.8-.8S8.4 3.5 8 3.5z"
    })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
      d: "M8,15c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S11.9,15,8,15z M8,2C4.7,2,2,4.7,2,8s2.7,6,6,6s6-2.7,6-6S11.3,2,8,2z"
    })), children);
  }

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Information.propTypes = iconPropTypes;
}
var InformationDisabled = /*#__PURE__*/React.forwardRef(function InformationDisabled(_ref68, ref) {
  var children = _ref68.children,
      _ref68$size = _ref68.size,
      size = _ref68$size === void 0 ? 16 : _ref68$size,
      rest = _objectWithoutProperties(_ref68, _excluded68);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.4141L28.5859 2 2 28.5859 3.4141 30l3.4433-3.4434A13.9614 13.9614 0 0026.5565 6.8574zM28 16A11.9734 11.9734 0 018.2678 25.146L15 18.4141V22H13v2h7V22H17V16.4141l8.146-8.146A11.8967 11.8967 0 0128 16zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67,22.0854A11.9829,11.9829,0,0,1,22.0856,5.67L23.54,4.2163A13.985,13.985,0,0,0,4.2162,23.54Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  InformationDisabled.propTypes = iconPropTypes;
}
var InformationFilled = /*#__PURE__*/React.forwardRef(function InformationFilled(_ref69, ref) {
  var children = _ref69.children,
      _ref69$size = _ref69.size,
      size = _ref69$size === void 0 ? 16 : _ref69$size,
      rest = _objectWithoutProperties(_ref69, _excluded69);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z",
    "data-icon-path": "inner-path"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,6a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  InformationFilled.propTypes = iconPropTypes;
}
var InformationSquare = /*#__PURE__*/React.forwardRef(function InformationSquare(_ref70, ref) {
  var children = _ref70.children,
      _ref70$size = _ref70.size,
      size = _ref70$size === void 0 ? 16 : _ref70$size,
      rest = _objectWithoutProperties(_ref70, _excluded70);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26V6Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  InformationSquare.propTypes = iconPropTypes;
}
var InformationSquareFilled = /*#__PURE__*/React.forwardRef(function InformationSquareFilled(_ref71, ref) {
  var children = _ref71.children,
      _ref71$size = _ref71.size,
      size = _ref71$size === void 0 ? 16 : _ref71$size,
      rest = _objectWithoutProperties(_ref71, _excluded71);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z",
    "data-icon-path": "inner-path"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  InformationSquareFilled.propTypes = iconPropTypes;
}
var InfrastructureClassic = /*#__PURE__*/React.forwardRef(function InfrastructureClassic(_ref72, ref) {
  var children = _ref72.children,
      _ref72$size = _ref72.size,
      size = _ref72$size === void 0 ? 16 : _ref72$size,
      rest = _objectWithoutProperties(_ref72, _excluded72);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26H30V28H18zM18 21H30V23H18zM18 16H30V18H18z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M14,25H9.5A7.4964,7.4964,0,0,1,8.1782,10.124,10,10,0,0,1,28,12H26a7.999,7.999,0,0,0-15.9507-.87l-.09.8335L9.123,12.02A5.4962,5.4962,0,0,0,9.5,23H14Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  InfrastructureClassic.propTypes = iconPropTypes;
}
var Insert = /*#__PURE__*/React.forwardRef(function Insert(_ref73, ref) {
  var children = _ref73.children,
      _ref73$size = _ref73.size,
      size = _ref73$size === void 0 ? 16 : _ref73$size,
      rest = _objectWithoutProperties(_ref73, _excluded73);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9h9V2H2zM4 4H9V7H4zM2 19h9V12H2zm2-5H9v3H4zM2 29h9V22H2zm2-5H9v3H4zM27 9H18l3.41-3.59L20 4l-6 6 6 6 1.41-1.41L18 11h9a1 1 0 011 1V24a1 1 0 01-1 1H15v2H27a3 3 0 003-3V12A3 3 0 0027 9z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Insert.propTypes = iconPropTypes;
}
var InsertPage = /*#__PURE__*/React.forwardRef(function InsertPage(_ref74, ref) {
  var children = _ref74.children,
      _ref74$size = _ref74.size,
      size = _ref74$size === void 0 ? 16 : _ref74$size,
      rest = _objectWithoutProperties(_ref74, _excluded74);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30H24V20H12V30H10V20a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2zM5.17 16L2 19.17 3.411 20.589 8 16 3.42 11.42 2 12.83 5.17 16zM24 14H12a2.0021 2.0021 0 01-2-2V2h2V12H24V2h2V12A2.0021 2.0021 0 0124 14z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  InsertPage.propTypes = iconPropTypes;
}
var InsertSyntax = /*#__PURE__*/React.forwardRef(function InsertSyntax(_ref75, ref) {
  var children = _ref75.children,
      _ref75$size = _ref75.size,
      size = _ref75$size === void 0 ? 16 : _ref75$size,
      rest = _objectWithoutProperties(_ref75, _excluded75);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M20.17 16L17.59 18.58 19 20 23 16 19 12 17.58 13.41 20.17 16zM11.83 16L14.41 13.42 13 12 9 16 13 20 14.42 18.59 11.83 16z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22.142V9.858A3.9916,3.9916,0,1,0,22.142,5H9.858A3.9916,3.9916,0,1,0,5,9.858V22.142A3.9916,3.9916,0,1,0,9.858,27H22.142A3.9916,3.9916,0,1,0,27,22.142ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm16.142-3H9.858A3.9937,3.9937,0,0,0,7,22.142V9.858A3.9947,3.9947,0,0,0,9.858,7H22.142A3.9937,3.9937,0,0,0,25,9.858V22.142A3.9931,3.9931,0,0,0,22.142,25ZM26,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  InsertSyntax.propTypes = iconPropTypes;
}
var Inspection = /*#__PURE__*/React.forwardRef(function Inspection(_ref76, ref) {
  var children = _ref76.children,
      _ref76$size = _ref76.size,
      size = _ref76$size === void 0 ? 16 : _ref76$size,
      rest = _objectWithoutProperties(_ref76, _excluded76);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.18L12.41 14.59 11 16 15 20 22 13 20.59 11.59 15 17.18z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H27.9492A12.0071,12.0071,0,0,0,17,4.0508V2H15V4.0508A12.0071,12.0071,0,0,0,4.0508,15H2v2H4.0508A12.0071,12.0071,0,0,0,15,27.9492V30h2V27.9492A12.0071,12.0071,0,0,0,27.9492,17H30ZM17,25.9492V23H15v2.9492A10.0166,10.0166,0,0,1,6.0508,17H9V15H6.0508A10.0166,10.0166,0,0,1,15,6.0508V9h2V6.0508A10.0166,10.0166,0,0,1,25.9492,15H23v2h2.949A10.0165,10.0165,0,0,1,17,25.9492Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Inspection.propTypes = iconPropTypes;
}
var InstanceBx = /*#__PURE__*/React.forwardRef(function InstanceBx(_ref77, ref) {
  var children = _ref77.children,
      _ref77$size = _ref77.size,
      size = _ref77$size === void 0 ? 16 : _ref77$size,
      rest = _objectWithoutProperties(_ref77, _excluded77);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5A3.0033 3.0033 0 009 2H4V15H9a3.0033 3.0033 0 003-3V10.5a2.977 2.977 0 00-.78-2 2.9768 2.9768 0 00.78-2zM6 4H9a1.0013 1.0013 0 011 1V6.5513A.9587.9587 0 019 7.5H6zm4 8a1.0009 1.0009 0 01-1 1H6V9.5H9a1.0009 1.0009 0 011 1zM22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5z"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "27",
    r: "1"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  InstanceBx.propTypes = iconPropTypes;
}
var InstanceClassic = /*#__PURE__*/React.forwardRef(function InstanceClassic(_ref78, ref) {
  var children = _ref78.children,
      _ref78$size = _ref78.size,
      size = _ref78$size === void 0 ? 16 : _ref78$size,
      rest = _objectWithoutProperties(_ref78, _excluded78);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,21H23V19h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,19H9v2H8.5A6.4973,6.4973,0,0,1,7.2,8.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,21Z"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "27",
    r: "1"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M26,23H17V15.83l2.59,2.58L21,17l-5-5-5,5,1.41,1.41L15,15.83V23H6a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V25A2.0023,2.0023,0,0,0,26,23Zm0,6H6V25H26Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  InstanceClassic.propTypes = iconPropTypes;
}
var InstanceCx = /*#__PURE__*/React.forwardRef(function InstanceCx(_ref79, ref) {
  var children = _ref79.children,
      _ref79$size = _ref79.size,
      size = _ref79$size === void 0 ? 16 : _ref79$size,
      rest = _objectWithoutProperties(_ref79, _excluded79);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "27",
    r: "1"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5zM12 15H6a2.0023 2.0023 0 01-2-2V4A2.002 2.002 0 016 2h6V4H6v9h6zM2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  InstanceCx.propTypes = iconPropTypes;
}
var InstanceMx = /*#__PURE__*/React.forwardRef(function InstanceMx(_ref80, ref) {
  var children = _ref80.children,
      _ref80$size = _ref80.size,
      size = _ref80$size === void 0 ? 16 : _ref80$size,
      rest = _objectWithoutProperties(_ref80, _excluded80);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5zM10 2L8.485 6.374 8 8 7.535 6.374 6 2 4 2 4 15 6 15 6 7.374 5.841 5.378 6.421 7.374 8 12 9.579 7.374 10.159 5.374 10 7.374 10 15 12 15 12 2 10 2z"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "27",
    r: "1"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  InstanceMx.propTypes = iconPropTypes;
}
var InstanceVirtual = /*#__PURE__*/React.forwardRef(function InstanceVirtual(_ref81, ref) {
  var children = _ref81.children,
      _ref81$size = _ref81.size,
      size = _ref81$size === void 0 ? 16 : _ref81$size,
      rest = _objectWithoutProperties(_ref81, _excluded81);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "23",
    r: "1"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H6V8H2zM8 6H12V8H8zM14 6H18V8H14zM20 6H24V8H20zM26 6H30V8H26zM28 28H4a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 28zM4 20v6H28V20zM2 12H30V14H2z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  InstanceVirtual.propTypes = iconPropTypes;
}
var Integration = /*#__PURE__*/React.forwardRef(function Integration(_ref82, ref) {
  var children = _ref82.children,
      _ref82$size = _ref82.size,
      size = _ref82$size === void 0 ? 16 : _ref82$size,
      rest = _objectWithoutProperties(_ref82, _excluded82);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M29.88,15.52l-6-11A1,1,0,0,0,23,4H9a1,1,0,0,0-.88.52l-6,11a1,1,0,0,0,0,1l6,11A1,1,0,0,0,9,28H23a1,1,0,0,0,.88-.52l6-11A1,1,0,0,0,29.88,15.52ZM22.93,7l4.39,8h-9.5ZM16,14.14,10.82,6H21.18ZM9.07,7l5.11,8H4.68ZM4.68,17h9.5L9.07,25ZM16,17.86,21.18,26H10.82ZM22.93,25l-5.11-8h9.5Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Integration.propTypes = iconPropTypes;
}
var IntentRequestActive = /*#__PURE__*/React.forwardRef(function IntentRequestActive(_ref83, ref) {
  var children = _ref83.children,
      _ref83$size = _ref83.size,
      size = _ref83$size === void 0 ? 16 : _ref83$size,
      rest = _objectWithoutProperties(_ref83, _excluded83);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27.2L20.4 24.6 19 26 23 30 31 22 29.6 20.6z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9 c0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IntentRequestActive.propTypes = iconPropTypes;
}
var IntentRequestCreate = /*#__PURE__*/React.forwardRef(function IntentRequestCreate(_ref84, ref) {
  var children = _ref84.children,
      _ref84$size = _ref84.size,
      size = _ref84$size === void 0 ? 16 : _ref84$size,
      rest = _objectWithoutProperties(_ref84, _excluded84);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24L26 24 26 20 24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9 c0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IntentRequestCreate.propTypes = iconPropTypes;
}
var IntentRequestHeal = /*#__PURE__*/React.forwardRef(function IntentRequestHeal(_ref85, ref) {
  var children = _ref85.children,
      _ref85$size = _ref85.size,
      size = _ref85$size === void 0 ? 16 : _ref85$size,
      rest = _objectWithoutProperties(_ref85, _excluded85);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M27,20c-0.8,0-1.5,0.3-2.1,0.9l-0.4,0.5l-0.4-0.5C23.5,20.3,22.7,20,22,20s-1.5,0.3-2.1,0.9c-1.2,1.2-1.2,3.1,0,4.3l4.6,4.8 l4.6-4.8c1.2-1.2,1.2-3.1,0-4.3C28.6,20.3,27.8,20,27,20L27,20z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6,28.6L4,16L16,4l12.6,12.6l1.4-1.4L17.5,2.6c-0.8-0.8-2.1-0.8-2.9,0L2.6,14.5c-0.8,0.8-0.8,2.1,0,2.9L15.1,30 L16.6,28.6z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IntentRequestHeal.propTypes = iconPropTypes;
}
var IntentRequestInactive = /*#__PURE__*/React.forwardRef(function IntentRequestInactive(_ref86, ref) {
  var children = _ref86.children,
      _ref86$size = _ref86.size,
      size = _ref86$size === void 0 ? 16 : _ref86$size,
      rest = _objectWithoutProperties(_ref86, _excluded86);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "18.5",
    cy: "22.5",
    r: "1.5"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "23.5",
    cy: "22.5",
    r: "1.5"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "28.5",
    cy: "22.5",
    r: "1.5"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9 c0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IntentRequestInactive.propTypes = iconPropTypes;
}
var IntentRequestScaleIn = /*#__PURE__*/React.forwardRef(function IntentRequestScaleIn(_ref87, ref) {
  var children = _ref87.children,
      _ref87$size = _ref87.size,
      size = _ref87$size === void 0 ? 16 : _ref87$size,
      rest = _objectWithoutProperties(_ref87, _excluded87);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6 30L30 28.6 22.4 21 29 21 29 19 19 19 19 29 21 29 21 22.4zM2 28.6L3.4 30 11 22.4 11 29 13 29 13 19 3 19 3 21 9.6 21zM17 2L15 2 15 12.2 10.4 7.6 9 9 16 16 23 9 21.6 7.6 17 12.2z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IntentRequestScaleIn.propTypes = iconPropTypes;
}
var IntentRequestScaleOut = /*#__PURE__*/React.forwardRef(function IntentRequestScaleOut(_ref88, ref) {
  var children = _ref88.children,
      _ref88$size = _ref88.size,
      size = _ref88$size === void 0 ? 16 : _ref88$size,
      rest = _objectWithoutProperties(_ref88, _excluded88);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M19 20.4L20.4 19 28 26.6 28 20 30 20 30 30 20 30 20 28 26.6 28zM13 20.4L11.6 19 4 26.6 4 20 2 20 2 30 12 30 12 28 5.4 28zM17 16L15 16 15 5.8 10.4 10.4 9 9 16 2 23 9 21.6 10.4 17 5.8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IntentRequestScaleOut.propTypes = iconPropTypes;
}
var IntentRequestUninstall = /*#__PURE__*/React.forwardRef(function IntentRequestUninstall(_ref89, ref) {
  var children = _ref89.children,
      _ref89$size = _ref89.size,
      size = _ref89$size === void 0 ? 16 : _ref89$size,
      rest = _objectWithoutProperties(_ref89, _excluded89);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M30 21.4L28.6 20 25 23.6 21.4 20 20 21.4 23.6 25 20 28.6 21.4 30 25 26.4 28.6 30 30 28.6 26.4 25z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9 c0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IntentRequestUninstall.propTypes = iconPropTypes;
}
var IntentRequestUpgrade = /*#__PURE__*/React.forwardRef(function IntentRequestUpgrade(_ref90, ref) {
  var children = _ref90.children,
      _ref90$size = _ref90.size,
      size = _ref90$size === void 0 ? 16 : _ref90$size,
      rest = _objectWithoutProperties(_ref90, _excluded90);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23L26.6 24.4 24 21.8 24 30 22 30 22 21.8 19.4 24.4 18 23 23 18z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9 c0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IntentRequestUpgrade.propTypes = iconPropTypes;
}
var Interactions = /*#__PURE__*/React.forwardRef(function Interactions(_ref91, ref) {
  var children = _ref91.children,
      _ref91$size = _ref91.size,
      size = _ref91$size === void 0 ? 16 : _ref91$size,
      rest = _objectWithoutProperties(_ref91, _excluded91);

  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M11,7 L11,9 L13,9 C13.5522847,9 14,9.44771525 14,10 L14,10 L14,13 C14,13.5522847 13.5522847,14 13,14 L13,14 L10,14 L10,7 L11,7 Z M5,9 C5.55228475,9 6,9.44771525 6,10 L6,10 L6,14 L3,14 C2.44771525,14 2,13.5522847 2,13 L2,13 L2,12 C2,11.4477153 2.44771525,11 3,11 L3,11 L5,11 L5,10 L2.5,10 L2.5,9 Z M13,10 L11,10 L11,13 L13,13 L13,10 Z M5,12 L3,12 L3,13 L5,13 L5,12 Z M7.912,2 L7.834,3.911 L9.628,3.248 L9.914,4.119 L8.068,4.626 L9.251,6.134 L8.523,6.667 L7.457,5.068 L6.391,6.667 L5.663,6.134 L6.846,4.626 L5,4.119 L5.286,3.248 L7.08,3.911 L7.002,2 L7.912,2 Z"
    })), children);
  }

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18H22V14H20V28h6a2.0027 2.0027 0 002-2V20A2.0023 2.0023 0 0026 18zm-4 8V20h4v6zM20 6.076L19.256 4.219 16 5.522 16 2 14 2 14 5.523 10.744 4.22 10 6.077 13.417 7.444 10.9 10.8 12.5 12 15 8.667 17.5 12 19.1 10.8 16.583 7.443 20 6.076zM10 18H5v2h5v2H6a2 2 0 00-2 2v2a2 2 0 002 2h6V20A2.0023 2.0023 0 0010 18zm0 8H6V24h4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Interactions.propTypes = iconPropTypes;
}
var WatsonHealthInteractiveSegmentationCursor = /*#__PURE__*/React.forwardRef(function WatsonHealthInteractiveSegmentationCursor(_ref92, ref) {
  var children = _ref92.children,
      _ref92$size = _ref92.size,
      size = _ref92$size === void 0 ? 16 : _ref92$size,
      rest = _objectWithoutProperties(_ref92, _excluded92);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4139,24,15.9989,10.5663a2.0473,2.0473,0,0,0-2.8281,0l-2.586,2.586a2.0023,2.0023,0,0,0,0,2.8283L23.9989,29.4145a2.0021,2.0021,0,0,0,2.8281,0l2.5869-2.5865a1.9993,1.9993,0,0,0,0-2.8283Zm-17.415-9.4335,2.5859-2.5859,3.5,3.5L15.498,18.0676l-3.5-3.5ZM25.413,28l-8.5009-8.5188,2.5867-2.587L28,25.4143Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M7.586 18.586H10.414V21.413999999999998H7.586z",
    transform: "rotate(-45 9 20)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M18.586 7.586H21.413999999999998V10.414H18.586z",
    transform: "rotate(-45 20 9)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M7.586 7.586H10.414V10.414H7.586z",
    transform: "rotate(-45 9 9)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthInteractiveSegmentationCursor.propTypes = iconPropTypes;
}
var Intersect = /*#__PURE__*/React.forwardRef(function Intersect(_ref93, ref) {
  var children = _ref93.children,
      _ref93$size = _ref93.size,
      size = _ref93$size === void 0 ? 16 : _ref93$size,
      rest = _objectWithoutProperties(_ref93, _excluded93);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24H18V22h4V18h2v4A2.0021 2.0021 0 0122 24zM10 14H8V10a2.0022 2.0022 0 012-2h4v2H10z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8Zm0,20H10V24h4V22H10V18H8v4H4V4H22V8H18v2h4v4h2V10h4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Intersect.propTypes = iconPropTypes;
}
var IntrusionPrevention = /*#__PURE__*/React.forwardRef(function IntrusionPrevention(_ref94, ref) {
  var children = _ref94.children,
      _ref94$size = _ref94.size,
      size = _ref94$size === void 0 ? 16 : _ref94$size,
      rest = _objectWithoutProperties(_ref94, _excluded94);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "23.887",
    r: "2"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM25 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H25a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0125 10zM4 4V8H25V4zM12 28H4V24h8V22H4a2.0023 2.0023 0 00-2 2v4a2.0023 2.0023 0 002 2h8z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H7a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h5V18H7V14H28l.0007,2H30V14A2.0023,2.0023,0,0,0,28,12Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IntrusionPrevention.propTypes = iconPropTypes;
}
var InventoryManagement = /*#__PURE__*/React.forwardRef(function InventoryManagement(_ref95, ref) {
  var children = _ref95.children,
      _ref95$size = _ref95.size,
      size = _ref95$size === void 0 ? 16 : _ref95$size,
      rest = _objectWithoutProperties(_ref95, _excluded95);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M19 24H23V28H19zM26 24H30V28H26zM19 17H23V21H19zM26 17H30V21H26z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M17,24H4V10H28v5h2V10a2.0023,2.0023,0,0,0-2-2H22V4a2.0023,2.0023,0,0,0-2-2H12a2.002,2.002,0,0,0-2,2V8H4a2.002,2.002,0,0,0-2,2V24a2.0023,2.0023,0,0,0,2,2H17ZM12,4h8V8H12Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  InventoryManagement.propTypes = iconPropTypes;
}
var IotConnect = /*#__PURE__*/React.forwardRef(function IotConnect(_ref96, ref) {
  var children = _ref96.children,
      _ref96$size = _ref96.size,
      size = _ref96$size === void 0 ? 16 : _ref96$size,
      rest = _objectWithoutProperties(_ref96, _excluded96);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2a4.0042,4.0042,0,0,0-4,4,3.9556,3.9556,0,0,0,.5668,2.0192L19.5859,11H11V21H21V12.4141l2.9808-2.9808A3.9553,3.9553,0,0,0,26,10a4,4,0,0,0,0-8ZM19,19H13V13h6ZM26,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,8Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IotConnect.propTypes = iconPropTypes;
}
var IotPlatform = /*#__PURE__*/React.forwardRef(function IotPlatform(_ref97, ref) {
  var children = _ref97.children,
      _ref97$size = _ref97.size,
      size = _ref97$size === void 0 ? 16 : _ref97$size,
      rest = _objectWithoutProperties(_ref97, _excluded97);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21H11V11H21zm-8-2h6V13H13zM31 13H29A10.0117 10.0117 0 0019 3V1A12.0131 12.0131 0 0131 13z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M26,13H24a5.0059,5.0059,0,0,0-5-5V6A7.0085,7.0085,0,0,1,26,13Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IotPlatform.propTypes = iconPropTypes;
}
var Iso = /*#__PURE__*/React.forwardRef(function Iso(_ref98, ref) {
  var children = _ref98.children,
      _ref98$size = _ref98.size,
      size = _ref98$size === void 0 ? 16 : _ref98$size,
      rest = _objectWithoutProperties(_ref98, _excluded98);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23H24a2 2 0 01-2-2V11a2 2 0 012-2h4a2 2 0 012 2V21A2 2 0 0128 23zM24 11V21h4V11zM18 23H12V21h6V17H14a2 2 0 01-2-2V11a2 2 0 012-2h6v2H14v4h4a2 2 0 012 2v4A2 2 0 0118 23zM2 11L5 11 5 21 2 21 2 23 10 23 10 21 7 21 7 11 10 11 10 9 2 9 2 11z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Iso.propTypes = iconPropTypes;
}
var IsoFilled = /*#__PURE__*/React.forwardRef(function IsoFilled(_ref99, ref) {
  var children = _ref99.children,
      _ref99$size = _ref99.size,
      size = _ref99$size === void 0 ? 16 : _ref99$size,
      rest = _objectWithoutProperties(_ref99, _excluded99);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13H24V19H21z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM8,21H6V11H8Zm9-8H12v2h3a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H10V19h5V17H12a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm9,6a2,2,0,0,1-2,2H21a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IsoFilled.propTypes = iconPropTypes;
}
var IsoOutline = /*#__PURE__*/React.forwardRef(function IsoOutline(_ref100, ref) {
  var children = _ref100.children,
      _ref100$size = _ref100.size,
      size = _ref100$size === void 0 ? 16 : _ref100$size,
      rest = _objectWithoutProperties(_ref100, _excluded100);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21H21a2 2 0 01-2-2V13a2 2 0 012-2h3a2 2 0 012 2v6A2 2 0 0124 21zm-3-8v6h3V13zM15 21H10V19h5V17H12a2 2 0 01-2-2V13a2 2 0 012-2h5v2H12v2h3a2 2 0 012 2v2A2 2 0 0115 21zM6 11H8V21H6z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  IsoOutline.propTypes = iconPropTypes;
}
var JoinFull = /*#__PURE__*/React.forwardRef(function JoinFull(_ref101, ref) {
  var children = _ref101.children,
      _ref101$size = _ref101.size,
      size = _ref101$size === void 0 ? 16 : _ref101$size,
      rest = _objectWithoutProperties(_ref101, _excluded101);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,9.0752a7.9941,7.9941,0,0,1,0,13.85,7.9941,7.9941,0,0,1,0-13.85m0-2.2373a9.9953,9.9953,0,0,0,0,18.3242A9.9953,9.9953,0,0,0,16,6.8379Z",
    "data-icon-path": "inner-path"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16a9.9976,9.9976,0,0,1,6-9.1621,10,10,0,1,0,0,18.3242A9.9976,9.9976,0,0,1,10,16Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M16,9.0752a7.9941,7.9941,0,0,0,0,13.85,7.9941,7.9941,0,0,0,0-13.85Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M20,6a9.9539,9.9539,0,0,0-4,.8379,9.9953,9.9953,0,0,1,0,18.3242A9.9988,9.9988,0,1,0,20,6Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  JoinFull.propTypes = iconPropTypes;
}
var JoinInner = /*#__PURE__*/React.forwardRef(function JoinInner(_ref102, ref) {
  var children = _ref102.children,
      _ref102$size = _ref102.size,
      size = _ref102$size === void 0 ? 16 : _ref102$size,
      rest = _objectWithoutProperties(_ref102, _excluded102);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M20,6a9.9355,9.9355,0,0,0-4,.8418A9.999,9.999,0,1,0,16,25.16,9.998,9.998,0,1,0,20,6ZM12,24A8,8,0,1,1,13.7573,8.2017a9.9734,9.9734,0,0,0,0,15.5986A7.9919,7.9919,0,0,1,12,24Zm8,0a7.9919,7.9919,0,0,1-1.7573-.2,9.9734,9.9734,0,0,0,0-15.5986A7.9972,7.9972,0,1,1,20,24Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  JoinInner.propTypes = iconPropTypes;
}
var JoinLeft = /*#__PURE__*/React.forwardRef(function JoinLeft(_ref103, ref) {
  var children = _ref103.children,
      _ref103$size = _ref103.size,
      size = _ref103$size === void 0 ? 16 : _ref103$size,
      rest = _objectWithoutProperties(_ref103, _excluded103);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M20,6a9.9272,9.9272,0,0,0-3.9968.8394,9.9758,9.9758,0,0,1,2.2451,1.36,8,8,0,1,1,0,15.6016,9.9758,9.9758,0,0,1-2.2451,1.36A9.9976,9.9976,0,1,0,20,6Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M12,16a8.01,8.01,0,0,0,6.2483,7.8008,9.9858,9.9858,0,0,0,0-15.6016A8.01,8.01,0,0,0,12,16Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M12,16a8.01,8.01,0,0,1,6.2483-7.8008,9.9758,9.9758,0,0,0-2.2451-1.36,9.9909,9.9909,0,0,0,0,18.3212,9.9758,9.9758,0,0,0,2.2451-1.36A8.01,8.01,0,0,1,12,16Z",
    "data-icon-path": "inner-path"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16a10.0105,10.0105,0,0,1,6.0032-9.1606,10,10,0,1,0,0,18.3212A10.0105,10.0105,0,0,1,10,16Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  JoinLeft.propTypes = iconPropTypes;
}
var JoinOuter = /*#__PURE__*/React.forwardRef(function JoinOuter(_ref104, ref) {
  var children = _ref104.children,
      _ref104$size = _ref104.size,
      size = _ref104$size === void 0 ? 16 : _ref104$size,
      rest = _objectWithoutProperties(_ref104, _excluded104);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6a9.9539 9.9539 0 00-4 .8379 9.9953 9.9953 0 010 18.3242A9.9988 9.9988 0 1020 6zM10 16a9.9976 9.9976 0 016-9.1621 10 10 0 100 18.3242A9.9976 9.9976 0 0110 16z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  JoinOuter.propTypes = iconPropTypes;
}
var JoinRight = /*#__PURE__*/React.forwardRef(function JoinRight(_ref105, ref) {
  var children = _ref105.children,
      _ref105$size = _ref105.size,
      size = _ref105$size === void 0 ? 16 : _ref105$size,
      rest = _objectWithoutProperties(_ref105, _excluded105);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M20,6a9.95,9.95,0,0,0-4.0032.8394,9.9909,9.9909,0,0,1,0,18.3212A9.9988,9.9988,0,1,0,20,6Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20,16a8.01,8.01,0,0,0-6.2483-7.8008,9.9758,9.9758,0,0,1,2.2451-1.36,9.9909,9.9909,0,0,1,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A8.01,8.01,0,0,0,20,16Z",
    "data-icon-path": "inner-path"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16a9.9759,9.9759,0,0,0,3.7517,7.8008,7.9937,7.9937,0,0,0,0-15.6016A9.9759,9.9759,0,0,0,10,16Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M12,24A8,8,0,1,1,13.7517,8.1992a9.9758,9.9758,0,0,1,2.2451-1.36,10,10,0,1,0,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A7.9727,7.9727,0,0,1,12,24Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  JoinRight.propTypes = iconPropTypes;
}
var Jpg = /*#__PURE__*/React.forwardRef(function Jpg(_ref106, ref) {
  var children = _ref106.children,
      _ref106$size = _ref106.size,
      size = _ref106$size === void 0 ? 16 : _ref106$size,
      rest = _objectWithoutProperties(_ref106, _excluded106);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 23H4a2 2 0 01-2-2V19H4v2H8V9h2V21A2 2 0 018 23z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Jpg.propTypes = iconPropTypes;
}
var Json = /*#__PURE__*/React.forwardRef(function Json(_ref107, ref) {
  var children = _ref107.children,
      _ref107$size = _ref107.size,
      size = _ref107$size === void 0 ? 16 : _ref107$size,
      rest = _objectWithoutProperties(_ref107, _excluded107);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M31 11L31 21 29 21 27 15 27 21 25 21 25 11 27 11 29 17 29 11 31 11zM21.3335 21h-2.667A1.6684 1.6684 0 0117 19.3335v-6.667A1.6684 1.6684 0 0118.6665 11h2.667A1.6684 1.6684 0 0123 12.6665v6.667A1.6684 1.6684 0 0121.3335 21zM19 19h2V13H19zM13.3335 21H9V19h4V17H11a2.002 2.002 0 01-2-2V12.6665A1.6684 1.6684 0 0110.6665 11H15v2H11v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0113.3335 21zM5.3335 21H2.6665A1.6684 1.6684 0 011 19.3335V17H3v2H5V11H7v8.3335A1.6684 1.6684 0 015.3335 21z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Json.propTypes = iconPropTypes;
}
var JsonReference = /*#__PURE__*/React.forwardRef(function JsonReference(_ref108, ref) {
  var children = _ref108.children,
      _ref108$size = _ref108.size,
      size = _ref108$size === void 0 ? 16 : _ref108$size,
      rest = _objectWithoutProperties(_ref108, _excluded108);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM29 12L27 6 25 6 25 16 27 16 27 10 29 16 31 16 31 6 29 6 29 12zM21.3335 6h-2.667A1.6683 1.6683 0 0017 7.6665v6.667A1.6684 1.6684 0 0018.6665 16h2.667A1.6683 1.6683 0 0023 14.3335V7.6665A1.6683 1.6683 0 0021.3335 6zM21 14H19V8h2zM9 7.6665V10a2.002 2.002 0 002 2h2v2H9v2h4.3335A1.6683 1.6683 0 0015 14.3335V12a2.002 2.002 0 00-2-2H11V8h4V6H10.6665A1.6683 1.6683 0 009 7.6665zM5 14H3V12H1v2.3335A1.6684 1.6684 0 002.6665 16h2.667A1.6683 1.6683 0 007 14.3335V6H5z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  JsonReference.propTypes = iconPropTypes;
}
var JumpLink = /*#__PURE__*/React.forwardRef(function JumpLink(_ref109, ref) {
  var children = _ref109.children,
      _ref109$size = _ref109.size,
      size = _ref109$size === void 0 ? 16 : _ref109$size,
      rest = _objectWithoutProperties(_ref109, _excluded109);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4141,17.5859,18,22.1719V8H8V6H18a2.0024,2.0024,0,0,1,2,2V22.1719l4.5859-4.586L26,19l-7,7-7-7Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  JumpLink.propTypes = iconPropTypes;
}
var KeepDry = /*#__PURE__*/React.forwardRef(function KeepDry(_ref110, ref) {
  var children = _ref110.children,
      _ref110$size = _ref110.size,
      size = _ref110$size === void 0 ? 16 : _ref110$size,
      rest = _objectWithoutProperties(_ref110, _excluded110);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M25,10a3.8978,3.8978,0,0,1-4-3.777,3.9017,3.9017,0,0,1,.6533-2.0639L24.17.4141a1.0381,1.0381,0,0,1,1.6592,0L28.3154,4.11A3.9693,3.9693,0,0,1,29,6.223,3.8978,3.8978,0,0,1,25,10Zm0-7.2368L23.3438,5.2257A1.89,1.89,0,0,0,23,6.223a2.014,2.014,0,0,0,4,0,1.98,1.98,0,0,0-.375-1.0466Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9854,15.83a13.9726,13.9726,0,0,0-1.8147-4.8323L26.4329,12.001a12.092,12.092,0,0,1,1.07,2.2124A5.4079,5.4079,0,0,0,26,14a6.5439,6.5439,0,0,0-3.939,1.333,14.5177,14.5177,0,0,0-3.0456-8.9341A13.8858,13.8858,0,0,0,17,4.4014V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM9.939,15.333A6.5439,6.5439,0,0,0,6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4413,12.4413,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333ZM16,14a6.5526,6.5526,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0564-9.1763,3.4307,2.6768,4.009,6.9487,4.0522,9.1728A6.552,6.552,0,0,0,16,14Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  KeepDry.propTypes = iconPropTypes;
}
var Keyboard = /*#__PURE__*/React.forwardRef(function Keyboard(_ref111, ref) {
  var children = _ref111.children,
      _ref111$size = _ref111.size,
      size = _ref111$size === void 0 ? 16 : _ref111$size,
      rest = _objectWithoutProperties(_ref111, _excluded111);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H4a2,2,0,0,1-2-2V10A2,2,0,0,1,4,8H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,10V24H28V10Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20H21V22H10zM6 12H8V14H6zM10 12H12V14H10zM14 12H16V14H14zM18 12H20V14H18zM6 20H8V22H6zM6 16H8V18H6zM10 16H12V18H10zM14 16H16V18H14zM22 12H26V14H22zM22 16H26V18H22zM18 16H20V18H18zM23 20H26V22H23z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Keyboard.propTypes = iconPropTypes;
}
var KeyboardOff = /*#__PURE__*/React.forwardRef(function KeyboardOff(_ref112, ref) {
  var children = _ref112.children,
      _ref112$size = _ref112.size,
      size = _ref112$size === void 0 ? 16 : _ref112$size,
      rest = _objectWithoutProperties(_ref112, _excluded112);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H8V14H6zM18 12H20V14H18zM6 20H8V22H6zM6 16H8V18H6zM10 16H12V18H10zM22 12H26V14H22zM22 16H26V18H22z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 10H28v13h2V10c0-1.1-.9-2-2-2H12.2L14.2 10zM30 28.6L3.4 2 2 3.4 6.6 8H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h20.6l4 4L30 28.6zM4 24V10h4.6l2 2H10v2h2.6l2 2H14v2h2.6l2 2H10v2h10.6l2 2H4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  KeyboardOff.propTypes = iconPropTypes;
}
var Kubernetes = /*#__PURE__*/React.forwardRef(function Kubernetes(_ref113, ref) {
  var children = _ref113.children,
      _ref113$size = _ref113.size,
      size = _ref113$size === void 0 ? 16 : _ref113$size,
      rest = _objectWithoutProperties(_ref113, _excluded113);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation["Kubernetes"]) {
      didWarnAboutDeprecation["Kubernetes"] = true;
      console.warn("The current kubernetes icon has been replaced by logo--kubernetes. As a result, the Kubernetes component will be removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2227,17.9639,25.9194,17.21a9.7843,9.7843,0,0,0-1.5249-6.6245l2.54-2.0254L25.6875,6.9961,23.1482,9.0205A9.97,9.97,0,0,0,17,6.0508V3H15V6.0508a9.97,9.97,0,0,0-6.1482,2.97L6.3125,6.9961,5.0654,8.56l2.54,2.0254A9.7843,9.7843,0,0,0,6.0806,17.21l-3.3033.7544.4454,1.9492L6.52,19.1606a10.0359,10.0359,0,0,0,4.2688,5.358l-1.33,2.7631,1.8018.8677L12.59,25.3882a9.8113,9.8113,0,0,0,6.8208,0L20.74,28.1494l1.8018-.8682-1.33-2.7626a10.0359,10.0359,0,0,0,4.2688-5.358l3.2973.7525ZM24,16c0,.2573-.0148.5112-.0386.7627l-5-1.1416a2.9664,2.9664,0,0,0-.1376-.5942L22.82,11.84A7.9392,7.9392,0,0,1,24,16Zm-9,0a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,15,16Zm6.5758-5.7256L17.58,13.4609a3.0028,3.0028,0,0,0-.58-.2768V8.0693A7.9762,7.9762,0,0,1,21.5758,10.2744ZM15,8.0693v5.1148a3.0028,3.0028,0,0,0-.58.2768l-3.9956-3.1865A7.9762,7.9762,0,0,1,15,8.0693ZM8,16a7.9392,7.9392,0,0,1,1.18-4.16l3.9962,3.1866a2.9664,2.9664,0,0,0-.1376.5942l-5,1.1416C8.0148,16.5112,8,16.2573,8,16Zm.4835,2.7124,4.9752-1.1362a3.0132,3.0132,0,0,0,.4146.5366L11.6594,22.71A8.031,8.031,0,0,1,8.4835,18.7124ZM16,24a7.9679,7.9679,0,0,1-2.54-.42l2.2206-4.6123A2.9988,2.9988,0,0,0,16,19a2.9988,2.9988,0,0,0,.319-.0322L18.54,23.58A7.9546,7.9546,0,0,1,16,24Zm4.3406-1.29-2.2139-4.5976a3.0132,3.0132,0,0,0,.4146-.5366l4.9752,1.1362A8.031,8.031,0,0,1,20.3406,22.71Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Kubernetes.propTypes = iconPropTypes;
}
var Label = /*#__PURE__*/React.forwardRef(function Label(_ref114, ref) {
  var children = _ref114.children,
      _ref114$size = _ref114.size,
      size = _ref114$size === void 0 ? 16 : _ref114$size,
      rest = _objectWithoutProperties(_ref114, _excluded114);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M23 13H18v2h5v2H19a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2.0023 2.0023 0 0023 13zm0 8H19V19h4zM13 9H9a2.002 2.002 0 00-2 2V23H9V18h4v5h2V11A2.002 2.002 0 0013 9zM9 16V11h4v5z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Label.propTypes = iconPropTypes;
}
var Language = /*#__PURE__*/React.forwardRef(function Language(_ref115, ref) {
  var children = _ref115.children,
      _ref115$size = _ref115.size,
      size = _ref115$size === void 0 ? 16 : _ref115$size,
      rest = _objectWithoutProperties(_ref115, _excluded115);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19H24V21H18zM18 15H30V17H18zM18 11H30V13H18zM14 21V19H9V17H7v2H2v2h8.2148a8.5914 8.5914 0 01-2.2159 3.9771A9.2731 9.2731 0 016.5521 23H4.3334a10.8553 10.8553 0 002.1451 3.2966A14.6584 14.6584 0 013 28.127L3.7021 30a16.42 16.42 0 004.2907-2.3362A16.4883 16.4883 0 0012.2979 30L13 28.127A14.664 14.664 0 019.5228 26.3 10.3132 10.3132 0 0012.2516 21zM11.1666 13H13.333L8.75 2H6.5832L2 13H4.1664L5 11h5.3335zM5.8331 9L7.6665 4.6 9.5 9z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Language.propTypes = iconPropTypes;
}
var Laptop = /*#__PURE__*/React.forwardRef(function Laptop(_ref116, ref) {
  var children = _ref116.children,
      _ref116$size = _ref116.size,
      size = _ref116$size === void 0 ? 16 : _ref116$size,
      rest = _objectWithoutProperties(_ref116, _excluded116);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M26,24H6a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,6,6H26a2.0023,2.0023,0,0,1,2,2V22A2.0027,2.0027,0,0,1,26,24ZM6,8V22H26V8Z",
    transform: "translate(0 .005)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26.005H30V28.005H2z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Laptop.propTypes = iconPropTypes;
}
var Lasso = /*#__PURE__*/React.forwardRef(function Lasso(_ref117, ref) {
  var children = _ref117.children,
      _ref117$size = _ref117.size,
      size = _ref117$size === void 0 ? 16 : _ref117$size,
      rest = _objectWithoutProperties(_ref117, _excluded117);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M20,2H12A9.9842,9.9842,0,0,0,7.0349,20.6553C7.0249,20.7705,7,20.8818,7,21a3.9929,3.9929,0,0,0,2.9106,3.83A4.0049,4.0049,0,0,1,6,28H4v2H6a6.0044,6.0044,0,0,0,5.928-5.12,3.9966,3.9966,0,0,0,2.93-2.88H20A10,10,0,0,0,20,2ZM11,23a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,11,23Zm9-3H14.8579a3.9841,3.9841,0,0,0-7.15-1.2637A7.99,7.99,0,0,1,12,4h8a8,8,0,0,1,0,16Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Lasso.propTypes = iconPropTypes;
}
var LassoPolygon = /*#__PURE__*/React.forwardRef(function LassoPolygon(_ref118, ref) {
  var children = _ref118.children,
      _ref118$size = _ref118.size,
      size = _ref118$size === void 0 ? 16 : _ref118$size,
      rest = _objectWithoutProperties(_ref118, _excluded118);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6245,2.2193a1.0005,1.0005,0,0,0-1.0972-.1006L17.9353,7.8,3.366,2.0694a1,1,0,0,0-1.28,1.3369l6.4353,14.479A3.965,3.965,0,0,0,9.9106,24.83,4.0049,4.0049,0,0,1,6,28H4v2H6a6.0044,6.0044,0,0,0,5.928-5.12,4.0021,4.0021,0,0,0,2.93-2.88H23.24a2,2,0,0,0,1.9273-1.4649L29.9634,3.2676A1,1,0,0,0,29.6245,2.2193ZM11,23a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,11,23Zm12.24-3H14.8579a3.897,3.897,0,0,0-4.5117-2.9336L4.905,4.8238,18.0647,10,27.41,4.9878Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  LassoPolygon.propTypes = iconPropTypes;
}
var Launch = /*#__PURE__*/React.forwardRef(function Launch(_ref119, ref) {
  var children = _ref119.children,
      _ref119$size = _ref119.size,
      size = _ref119$size === void 0 ? 16 : _ref119$size,
      rest = _objectWithoutProperties(_ref119, _excluded119);

  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
      d: "M13,14H3c-0.6,0-1-0.4-1-1V3c0-0.6,0.4-1,1-1h5v1H3v10h10V8h1v5C14,13.6,13.6,14,13,14z"
    })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
      d: "M10 1L10 2 13.3 2 9 6.3 9.7 7 14 2.7 14 6 15 6 15 1z"
    })), children);
  }

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0027,2.0027,0,0,1-2-2V6A2.0027,2.0027,0,0,1,6,4H16V6H6V26H26V16h2V26A2.0027,2.0027,0,0,1,26,28Z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2L20 4 26.586 4 18 12.586 19.414 14 28 5.414 28 12 30 12 30 2 20 2z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Launch.propTypes = iconPropTypes;
}
var WatsonHealthLaunchStudy_1 = /*#__PURE__*/React.forwardRef(function WatsonHealthLaunchStudy_1(_ref120, ref) {
  var children = _ref120.children,
      _ref120$size = _ref120.size,
      size = _ref120$size === void 0 ? 16 : _ref120$size,
      rest = _objectWithoutProperties(_ref120, _excluded120);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "25",
    r: "1"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M26 22v6H6V22H26m0-2H6a2 2 0 00-2 2v6a2 2 0 002 2H26a2 2 0 002-2V22a2 2 0 00-2-2zM20.59 10.59L17 14.17 17 2 15 2 15 14.17 11.41 10.59 10 12 16 18 22 12 20.59 10.59z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24H20V26H8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthLaunchStudy_1.propTypes = iconPropTypes;
}
var WatsonHealthLaunchStudy_2 = /*#__PURE__*/React.forwardRef(function WatsonHealthLaunchStudy_2(_ref121, ref) {
  var children = _ref121.children,
      _ref121$size = _ref121.size,
      size = _ref121$size === void 0 ? 16 : _ref121$size,
      rest = _objectWithoutProperties(_ref121, _excluded121);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "7",
    r: "1"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M26 4v6H6V4H26m0-2H6A2 2 0 004 4v6a2 2 0 002 2H26a2 2 0 002-2V4a2 2 0 00-2-2zM20.59 21.41L17 17.83 17 30 15 30 15 17.83 11.41 21.41 10 20 16 14 22 20 20.59 21.41z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H20V8H8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthLaunchStudy_2.propTypes = iconPropTypes;
}
var WatsonHealthLaunchStudy_3 = /*#__PURE__*/React.forwardRef(function WatsonHealthLaunchStudy_3(_ref122, ref) {
  var children = _ref122.children,
      _ref122$size = _ref122.size,
      size = _ref122$size === void 0 ? 16 : _ref122$size,
      rest = _objectWithoutProperties(_ref122, _excluded122);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "25",
    r: "1"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M26 22v6H6V22H26m0-2H6a2 2 0 00-2 2v6a2 2 0 002 2H26a2 2 0 002-2V22a2 2 0 00-2-2zM20.59 4.59L17 8.17 17 0 15 0 15 8.17 11.41 4.59 10 6 16 12 22 6 20.59 4.59z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 10.59L16 15.16 11.41 10.59 10 12 16 18 22 12 20.59 10.59zM8 24H20V26H8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthLaunchStudy_3.propTypes = iconPropTypes;
}
var Layers = /*#__PURE__*/React.forwardRef(function Layers(_ref123, ref) {
  var children = _ref123.children,
      _ref123$size = _ref123.size,
      size = _ref123$size === void 0 ? 16 : _ref123$size,
      rest = _objectWithoutProperties(_ref123, _excluded123);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a.9967.9967,0,0,1-.4741-.12l-13-7L3.4741,15.12,16,21.8643,28.5259,15.12l.9482,1.7607-13,7A.9967.9967,0,0,1,16,24Z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30a.9967.9967 0 01-.4741-.12l-13-7L3.4741 21.12 16 27.8643 28.5259 21.12l.9482 1.7607-13 7A.9967.9967 0 0116 30zM16 18a.9967.9967 0 01-.4741-.12l-13-7a1 1 0 010-1.7607l13-7a.9982.9982 0 01.9482 0l13 7a1 1 0 010 1.7607l-13 7A.9967.9967 0 0116 18zM5.1094 10L16 15.8643 26.8906 10 16 4.1358z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Layers.propTypes = iconPropTypes;
}
var Legend = /*#__PURE__*/React.forwardRef(function Legend(_ref124, ref) {
  var children = _ref124.children,
      _ref124$size = _ref124.size,
      size = _ref124$size === void 0 ? 16 : _ref124$size,
      rest = _objectWithoutProperties(_ref124, _excluded124);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22H30V24H16z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "6",
    height: "6",
    x: "4",
    y: "20",
    rx: "1"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8H30V10H16zM9.5 12h-5a.5.5 0 01-.4473-.7236l2.5-5.0224a.5206.5206 0 01.8945 0l2.5 5.0225A.5.5 0 019.5 12z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Legend.propTypes = iconPropTypes;
}
var LetterAa = /*#__PURE__*/React.forwardRef(function LetterAa(_ref125, ref) {
  var children = _ref125.children,
      _ref125$size = _ref125.size,
      size = _ref125$size === void 0 ? 16 : _ref125$size,
      rest = _objectWithoutProperties(_ref125, _excluded125);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M23 13H18v2h5v2H19a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2 2 0 0023 13zm0 8H19V19h4zM13 9H9a2 2 0 00-2 2V23H9V18h4v5h2V11A2 2 0 0013 9zM9 16V11h4v5z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  LetterAa.propTypes = iconPropTypes;
}

export { IbmCloudPakApplications, IbmCloudPakBusinessAutomation, IbmCloudPakData, IbmCloudPakIntegration, IbmCloudPakMantaAutomatedDataLineage, IbmCloudPakMulticloudMgmt, IbmCloudPakNetezza, IbmCloudPakNetworkAutomation, IbmCloudPakSecurity, IbmCloudPakSystem, IbmCloudPakWatsonAiops, IbmCloudPal, IbmCloudSecretsManager, IbmCloudSecurityComplianceCenter, IbmCloudSubnets, IbmCloudSysdigSecure, IbmCloudTransitGateway, IbmCloudVpcEndpoints, IbmSecurity, IbmSecurityServices, IbmWatsonAssistant, IbmWatsonDiscovery, IbmWatsonKnowledgeCatalog, IbmWatsonKnowledgeStudio, IbmWatsonLanguageTranslator, IbmWatsonMachineLearning, IbmWatsonNaturalLanguageClassifier, IbmWatsonNaturalLanguageUnderstanding, IbmWatsonOpenscale, IbmWatsonOrders, IbmWatsonQuery, IbmWatsonSpeechToText, IbmWatsonStudio, IbmWatsonTextToSpeech, IbmWatsonToneAnalyzer, IbmZCloudModStack, IbmZCloudProvisioning, IbmZOsPackageManager, IceAccretion, IceVision, IdManagement, Idea, Identification, Image, ImageCopy, ImageMedical, ImageReference, ImageSearch, ImageSearchAlt, ImageService, ImportExport, ImproveRelevance, InProgress, InProgressError, InProgressWarning, Incomplete, IncompleteCancel, IncompleteError, IncompleteWarning, IncreaseLevel, Industry, Information, InformationDisabled, InformationFilled, InformationSquare, InformationSquareFilled, InfrastructureClassic, Insert, InsertPage, InsertSyntax, Inspection, InstanceBx, InstanceClassic, InstanceCx, InstanceMx, InstanceVirtual, Integration, IntentRequestActive, IntentRequestCreate, IntentRequestHeal, IntentRequestInactive, IntentRequestScaleIn, IntentRequestScaleOut, IntentRequestUninstall, IntentRequestUpgrade, Interactions, Intersect, IntrusionPrevention, InventoryManagement, IotConnect, IotPlatform, Iso, IsoFilled, IsoOutline, JoinFull, JoinInner, JoinLeft, JoinOuter, JoinRight, Jpg, Json, JsonReference, JumpLink, KeepDry, Keyboard, KeyboardOff, Kubernetes, Label, Language, Laptop, Lasso, LassoPolygon, Launch, Layers, Legend, LetterAa, QID, WatsonHealthICa_2D, WatsonHealthImageAvailabilityLocal, WatsonHealthImageAvailabilityRetrieving, WatsonHealthImageAvailabilityUnavailable, WatsonHealthInteractiveSegmentationCursor, WatsonHealthLaunchStudy_1, WatsonHealthLaunchStudy_2, WatsonHealthLaunchStudy_3 };
